export default {
  /**
   * Số thuế phải nộp trên tờ khai điều chỉnh tăng/giảm:
   */
  TaxPayable: {
    GTGTDomesticProductionAndTrading:
      '1701 - Thuế giá trị gia tăng hàng sản xuất, kinh doanh trong nước (gồm cả dịch vụ trong lĩnh vực giàu khí)',
    GTGTImport: '1702 - Thuế giá trị gia tăng hàng nhập khẩu',
    GTGTOilExplorationAndProduction:
      '1704 - Thuế giá trị gia tăng từ hoạt động thăm dò và khai thác dầu, khí (gồm cả thuế giá trị gia tăng thu đối với dầu, khí khai thác theo hiệp định, hợp đồng thăm dò, khai thác dầu, khí bán ra trong nước)',
    GTGTLottery: '1705 - Thuế giá trị gia tăng từ hoạt động xổ số kiến thiết',
    OtherService: '1749 - Hàng hóa, dịch vụ khác',
  },

  /**
   * Số thuế đề nghị hoàn điều chỉnh tăng/giảm:
   */
  TaxRefund: {
    TaxRefundGTGT: '7551 - Hoàn thuế giá trị gia tăng',
    LateRefund:
      '7552 - Trả lãi do chậm hoàn trả thuế giá trị gia tăng; thuế tiêu thụ đặc biệt; thuế nhập khẩu theo chương trình ưu đãi thuế công nghiệp hỗ trợ',
    TaxRefundConsume:
      '7553 - Hoàn thuế tiêu thụ đặc biệt mặt hàng xăng khoáng nguyên liệu dùng để sản xuất, pha chế xăng sinh học theo Luật thuế tiêu thụ đặc biệt',
    TaxRefundImportCar: '7554 - Hoàn thuế nhập khẩu đối với chương trình ưu đãi thuế sản xuất, lắp ráp ô tô',
    TaxRefundSupportingIndustry: '7555 - Hoàn thuế nhập khẩu đối với chương trình ưu đãi thuế công nghiệp hỗ trợ',
    OtherRefund: '7599 - Hoàn khác',
  },

  /**
   * Vai trò quyền hạn
   */
  RoleAction: {
    Add: 'Thêm',
    View: 'Sử dụng',
    Edit: 'Sửa',
    Delete: 'Xóa',
    Posted: 'Ghi sổ',
    UnPost: 'Bỏ ghi',
    Print: 'In',
    ReleaseEInvoice: 'Phát hành hóa đơn điện tử',
    SendInvoice: 'Gửi hóa đơn cho khách hàng',
    ConvertIntoPaperVoucher: 'Chuyển thành chứng từ giấy',
    DownloadInvoice: 'Tải hóa đơn',
    CancelInvoice: 'Hủy hóa đơn',
  },

  /**
   * Trạng thái của form
   */
  FormState: {
    Add: 'Thêm',
    View: 'Xem',
    Edit: 'Sửa',
    Duplicate: 'Thêm',
    QuickAdd: 'Thêm nhanh',
  },
  /**
   * Giới tính
   */
  Gender: {
    Female: 'Nữ',
    Male: 'Nam',
    Other: 'Khác',
  },
  InDebt: {
    Debt: 'Dư nợ',
    ExcessYes: 'Dư có',
  },

  StatusReceipt: {
    All: 'Tất cả',
    ReceiptOrigin: 'Biên lai gốc',
    ReceiptDeleted: 'Biên lai xóa bỏ',
  },
  Operator: {
    And: 'Và',
    Or: 'Hoặc',
  },
  /**
   * toán tử filter
   */
  FilterOperator: {
    Contains: 'Chứa',
    Notcontains: 'Không chứa',
    StartsWith: 'Bắt đầu với',
    EndsWith: 'Kết thúc với',
    Null: '(Trống)',
    NotNull: '(Không trống)',
    Equals: 'Bằng',
    NotEquals: 'Khác',
    GreaterThan: 'Lớn hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThan: 'Nhỏ hơn',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    Between: 'Trong khoảng',
  },

  FilterOperatorSearch: {
    Contains: 'Chứa',
    Notcontains: 'Không chứa',
    StartsWith: 'Bắt đầu bằng',
    EndsWith: 'Kết thúc bằng',
    Null: '(Trống)',
    NotNull: '(Không trống)',
    Equals: 'Bằng',
    NotEquals: 'Khác',
    GreaterThan: 'Lớn hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThan: 'Nhỏ hơn',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    Between: 'Trong khoảng',
  },

  OrganizationUnitType: {
    Corporations: 'Tổng công ty',
    Group: 'Tập đoàn',
    Subsidiaries: 'Công ty con',
    Branch: 'Chi nhánh',
    Representative: 'Văn phòng đại điện',
    Office: 'Văn phòng',
    Center: 'Trung tâm',
    Department: 'Phòng ban',
    Team: 'NHóm/tổ/đội',
    Factory: 'Phân xưởng',
  },
  EmployeeType: {
    Probation: 'Thử việc',
    Office: 'Chính thức',
    Manage: 'Quản lý',
  },
  Period: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần tới hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng tới hiện tại',
    ThisQuarter: 'Quý này',
    FirstQuarterToPresent: 'Đầu quý tới hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm tới hiện tại',
    SixFirstMonth: 'Sáu tháng đầu năm',
    SixLastMonth: 'Sáu tháng cuối năm',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý I',
    FiscalII: 'Quý II',
    FiscalIII: 'Quý III',
    FiscalIV: 'Quý IV',
    Yesterday: 'Hôm qua',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    Tomorrow: 'Ngày mai',
    NextWeek: 'Tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tùy chọn',
  },
  PeriodReport: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần tới hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng tới hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm tới hiện tại',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý I',
    FiscalII: 'Quý II',
    FiscalIII: 'Quý III',
    FiscalIV: 'Quý IV',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    NextWeek: 'Tuần sau',
    Next4Week: 'Bốn tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tự chọn',
  },

  // Trạng thái kết quả kiểm tra định mức
  TestNormResultStatus: {
    Incorrect: 'Chưa phù hợp',
    Correct: 'Phù hợp',
    Irrelevant: 'Không đủ căn cứ',
  },

  // Chỉ lấy số của tháng (vqphong - 19/10/2022)
  PeriodMonth: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
  },
  AccountCategoryKind: {
    Debit: 'Dư Nợ',
    Credit: 'Dư Có',
    BothSide: 'Lưỡng tính',
  },
  Currency: {
    VND: 'VND',
    Dola: 'USD',
  },
  Pagination: {
    // Two: '2 bản ghi trên 1 trang',
    Ten: '10 bản ghi trên 1 trang',
    Twen: '20 bản ghi trên 1 trang',
    Thir: '30 bản ghi trên 1 trang',
    Fif: '50 bản ghi trên 1 trang',
    Hunder: '100 bản ghi trên 1 trang',
  },
  SalaryForm: {
    Coefficient: 'Hệ số',
    Amount: 'Số tiền',
  },
  MethodDistributeType: {
    Estimate: 'Dự toán',

    Payment: 'Lệnh chi tiền',
  },
  CashWithDrawType: {
    None: 'Không chọn',
    Advance: 'Tạm ứng - Dự toán',
    Spend: 'Thực chi - Dự toán',
    PayForAdvance: 'Thanh toán tạm ứng kho bạc',
    SpendForAdvance: 'Chi từ tạm ứng',
    RefundAdvance: 'Nộp trả - Tạm ứng',
    RefundExpense: 'Nộp trả - Thực chi',
    ReceiptExpense: 'Ghi thu - Ghi chi',
    CommuneReceiptNonePercent: 'Thu ngân sách xã hưởng 0%',
    RestorePlan: 'Khôi phục',
    OrderAdvanced: 'Lệnh chi tiền - Tạm ứng',
    OrderSpend: 'Lệnh chi tiền - Thực chi',
  },
  CashWithDrawTypeDesktop: {
    All: 'Tất cả',
    None: 'Không chọn',
    Advance: 'Tạm ứng - Dự toán',
    Spend: 'Thực chi - Dự toán',
    PayForAdvance: 'Thanh toán tạm ứng kho bạc',
    SpendForAdvance: 'Chi từ tạm ứng',
    RefundAdvance: 'Nộp trả - Tạm ứng',
    RefundExpense: 'Nộp trả - Thực chi',
    ReceiptExpense: 'Ghi thu - Ghi chi',
    CommuneReceiptNonePercent: 'Thu ngân sách xã hưởng 0%',
    RestorePlan: 'Khôi phục',
    BUReceiveBudgetPlan: 'Nhận dự toán đầu năm',
    BUReceiveBudgetPlanAddition: 'Nhận dự toán bổ sung',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    BUPlanCancel: 'Hủy dự toán',
    OrderAdvanced: 'Lệnh chi tiền - Tạm ứng',
    OrderSpend: 'Lệnh chi tiền - Thực chi',
  },
  SalagovReftype: {
    BUPlanWithdrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    BUPlanWithdrawTransfer: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawDeposit: 'Rút dự toán tiền gửi',
    BUPlanWithdrawCash: 'Rút dự toán tiền mặt',
    BAWithDrawSalary: 'Tiền gửi',
    CAPaymentSalary: 'Tiền mặt',
  },

  CashReceiptRefType: {
    CAReceipt: 'Phiếu thu',
    BUTreasuryWithdrawal: 'Rút tiền kho bạc',
  },

  BADepositRefType: {
    BADeposit: 'Nộp tiền kho bạc',
  },

  BAWithDrawRefType: {
    BAWithDraw: 'Chi tiền gửi',
    CashPaymentDepositSalary: 'Chi tiền gửi trả lương',
  },

  RefType: {
    NonVoucher: 'Không phải chứng từ',

    CAReceipt: 'Phiếu thu',

    CAPayment: 'Phiếu chi',

    BADeposit: 'Nộp tiền kho bạc',

    BUTreasuryWithdrawal: 'Rút tiền kho bạc',

    BAInternalTransfer: 'Chuyển tiền nội bộ',

    BAWithDraw: 'Chi tiền gửi',

    BUTransfer: 'Chuyển khoản kho bạc',

    CAAdjustPayment: 'Điều chỉnh kinh phí chi',

    CAAdjustReceipt: 'Điều chỉnh kinh phí thu',

    BUCommitmentRequest: 'Đề nghị cam kết chi',

    BUPlanAdjustCommit: 'Điều chỉnh cam kết chi',

    BUBudgetReserve: 'Dự toán giữ lại',

    BUPlanWdAdjustment: 'Điều chỉnh kinh phí',

    INInward: 'Nhập khác',

    INOutward: 'Phiếu xuất kho',

    InventoryInwardCash: 'Nhập mua bằng tiền mặt',

    InventoryInwardDeposit: 'Nhập mua bằng tiền gửi',

    InventoryTransfer: 'Chuyển kho',

    OpeningInventoryItem: 'Số dư ban đầu vật tư',

    FixedAssetIncrement: 'Ghi tăng TSCĐ',

    FixedAssetDecrement: 'Ghi giảm TSCĐ',

    FixedAssetAdjustment: 'Điều chỉnh TSCĐ',

    FixedAssetDepreciation: 'Hao mòn TSCĐ',

    ToolIncrement: 'Ghi tăng',

    ToolDecrement: 'Phiếu ghi giảm CCDC',

    ToolTransfer: 'Phiếu điều chuyển CCDC',

    FixedAssetTransfer: 'Điều chuyển phòng ban',

    OpeningFixedAsset: 'Số dư ban đầu TSCĐ',

    OpeningTool: 'Số dư ban đầu CCDC',

    SalarySheet: 'Bảng lương',

    GlPayrollExpense: 'Hạch toán chi phí lương, BH, KPCĐ',

    SUGeneralVoucher: 'Chứng từ nghiệp vụ khác',

    SUAccountTransfer: 'Phiếu kết chuyển tài khoản',

    SUVoucherList: 'Tổng hợp chứng từ cùng loại',

    BUExpenseReceipt: 'Bảng kê ghi thu - ghi chi',

    BUAdvancePayment: 'Bảng kê thanh toán tạm ứng',

    BUAdvanceExpence: 'Bảng kê chứng từ thực chi',

    ParallelVoucher: 'Chứng từ ghi đồng thời',

    OpeningAccount: 'Số dư đầu tài khoản khác',

    OpeningBudget: 'Số dư đầu mục lục ngân sách',

    OpeningAccountingObject: 'Số dư ban đầu đối tượng',

    OpeningFund: 'Số dư ban đầu quỹ',

    OpeningActivity: 'Số dư ban đầu Hoạt động tài chính',

    OpeningActivityAndAccountingObject: 'Số dư ban đầu Hoạt động tài chính và Đối tượng',

    OpeningBankAccount: 'Số dư ban đầu tài khoản ngân hàng',

    OpeningBudgetAndBankAccount: 'Số dư ban đầu MLNS và tài khoản ngân hàng',

    OpeningFundAndBankAccount: 'Số dư ban đầu Quỹ và tài khoản ngân hàng',

    RegisterVoucher: 'Chứng từ ghi sổ',

    EReceiptSummary: 'Bảng tổng hợp biên lai thu tiền',

    TranferReceiptClear: 'Kết chuyển chênh lệch thu, chi ngân sách xã',

    TranferPaymentClear: 'Kết chuyển chi ngân sách',

    TranferClosing: 'Kết chuyển cuối năm',

    TransferBudgetBalance: 'Kết chuyển kết dư sang thu ngân sách xã',

    TransferActivity: 'Kết chuyển hoạt động sự nghiệp',

    TransferBegining: 'Quyết toán dự toán chi ngân sách cuối năm',

    TranferReceiptClearInMonth13: 'Kết chuyển chênh lệch thu, chi ngân sách xã trong thời gian chỉnh lý',

    TranferPaymentClearInMonth13: 'Kết chuyển chi ngân sách trong thời gian chỉnh lý',

    TransferBalance: 'Kết chuyển kết dư ngân sách xã',

    TransferBalanceInMonth13: 'Kết chuyển kết dư ngân sách xã trong thời gian chỉnh lý',

    BUPlanExpenseByBudget: 'Dự toán chi theo MLNS',

    BUPlanExpenseByBudgetSupplement: 'Bổ sung Dự toán chi theo MLNS',

    BUPlanExpenseByBudgetSupplementAdjust: 'Điều chỉnh Dự toán chi theo MLNS',

    BUPlanExpenseByActivity342: 'Dự toán chi theo TT 342',

    BUPlanExpenseByActivitySupplement342: 'Bổ sung Dự toán chi theo TT 342',

    BUPlanExpenseByActivitySupplementAdjust342: 'Điều chỉnh Dự toán chi theo TT 342',

    BUPlanExpenseByActivity343: 'Dự toán chi theo TT343',

    BUPlanExpenseByActivitySupplement343: 'Bổ sung Dự toán chi theo TT343',

    BUPlanExpenseByActivitySupplementAdjust343: 'Điều chỉnh Dự toán chi theo TT343',

    BUPlanExpenseByActivity344: 'Dự toán chi theo TT344',

    BUPlanExpenseByActivitySupplement344: 'Bổ sung Dự toán chi theo TT344',

    BUPlanExpenseByActivitySupplementAdjust344: 'Điều chỉnh Dự toán chi theo TT344',

    BUPlanExpenseByActivityVt: 'Dự toán chi theo Vũ Thư',

    BUPlanExpenseByActivitySupplementVt: 'Bổ sung Dự toán chi theo Vũ Thư',

    BUPlanExpenseByActivitySupplementAdjustVt: 'Điều chỉnh Dự toán chi theo Vũ Thư',

    BUPlanReceiptAddMLNS: 'Dự toán thu theo MLNS',

    BUPlanReceiptAddMLNSSupplement: 'Bổ sung Dự toán thu theo MLNS',

    BUPlanReceiptAdjustMLNS: 'Điều chỉnh Dự toán thu theo MLNS',

    BUPlanReceiptAddTT342: 'Dự toán thu theo TT 342',

    BUPlanReceiptSupplementTT342: 'Bổ sung Dự toán thu theo TT 342',

    BUPlanReceiptAdjustTT342: 'Điều chỉnh Dự toán thu theo TT 342',

    BUPlanReceiptAddTT343: 'Dự toán thu theo TT343',

    BUPlanReceiptSupplementTT343: 'Bổ sung Dự toán thu theo TT343',

    BUPlanReceiptAdjustTT343: 'Điều chỉnh Dự toán thu theo TT343',

    BUPlanReceiptAddTT344: 'Dự toán thu theo TT344',

    BUPlanReceiptSupplementTT344: 'Bổ sung Dự toán thu theo TT344',

    BUPlanReceiptAdjustTT344: 'Điều chỉnh Dự toán thu theo TT344',

    BUReceiveBudgetPlan: 'Nhận dự toán đầu năm',

    BUReceiveBudgetPlanSupplement: 'Nhận dự toán bổ sung',

    BUPlanAdjustment: 'Điều chỉnh dự toán',

    BUPlanCancel: 'Hủy dự toán',

    CashPaymentDepositSalary: 'Chi tiền gửi trả lương',

    CashPaymentSalary: 'Phiếu chi trả lương',

    BUTransferDeposit: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',

    BUInvestmentPlanXDCB: 'Kế hoạch vốn đầu tư xây dựng cơ bản',

    FAVoucherIncreament: 'Ghi tăng TSCĐ từ QLTS.VN', //Ghi tăng TSCĐ từ QLTS.VN

    FAVoucherAdjustment: 'Điều chỉnh TSCĐ từ QLTS.VN', //Điều chỉnh TSCĐ từ QLTS.VN

    FAVoucherDepreciate: 'Lấy khấu hao TSCĐ từ QLTS.VN',

    FAVoucherDepreciation: 'Hao mòn TSCĐ từ QLTS.VN', //Hao mòn TSCĐ từ QLTS.VN

    FAVoucherDecrement: 'Ghi giảm TSCĐ từ QLTS.VN', //Ghi giảm TSCĐ từ QLTS.VN

    BUExpenseWithdrawAdjustment: 'Điều chỉnh kinh phí',

    ElectricReceipt: 'Biên lai điện tử',

    SalaryVoucher: 'Chứng từ trả lương, bảo hiểm',

    SalaryAccounting: 'Chứng từ hạch toán chi phí lương',

    // SalaryVoucherTreasury: 'Chứng từ trả lương, bảo hiểm',
    ConstructionBudget: 'Kế hoạch vốn đầu tư xây dựng cơ bản',
    BUFinancialActivities: 'Kế hoạch thu chi các hoạt động tài chính khác',

    BAAdvanceNSNN: 'Bảng kê nộp tiền NSNN',

    CAFundInventory: 'Biên bản kiểm kê quỹ',
  },

  RefTypeQLTS: {
    FAVoucherIncreament: 'Ghi tăng TSCĐ ', //Ghi tăng TSCĐ từ QLTS.VN

    FAVoucherAdjustment: 'Điều chỉnh TSCĐ ', //Điều chỉnh TSCĐ từ QLTS.VN

    FAVoucherDepreciate: 'Lấy khấu hao TSCĐ từ QLTS.VN',

    FAVoucherDepreciation: 'Hao mòn TSCĐ ', //Hao mòn TSCĐ từ QLTS.VN

    FAVoucherDecrement: 'Ghi giảm TSCĐ ', //Ghi giảm TSCĐ từ QLTS.VN
  },

  /**
   * Reftype của chứng từ salagov (Hiện tại fake trước do chưa có dữ liệu cụ thể trả về từ salagov)
   * @author nvthinh 10.4.2023
   */
  RefTypeFromSalagov: {
    Salary: 'Rút lương',
    BHXH: 'Nộp BHXH',
    KPCD: 'Nộp KPCĐ',
    Tax: 'Nộp thuế TNCN',
  },

  /**
   * @description Loại CT được sinh ra từ CT salagov
   * @author nvthinh 3.10.2023
   */
  RefTypeGeneratedFromSalagovVoucher: {
    CAPayment: 'Phiếu chi',
    BUTreasuryWithdrawal: 'Rút tiền kho bạc',
    BAWithDraw: 'Chi tiền gửi',
    BUTransfer: 'Chuyển khoản kho bạc',
    GlPayrollExpense: 'Hạch toán chi phí lương, BH, KPCĐ',
    BUTransferDeposit: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
  },

  ActivityType: {
    AbsoluteIndependent: 'Đơn vị hành chính được giao tự chủ kinh phí',
    NoFinancialAutonomy: 'Đơn vị hành chính không được giao tự chủ kinh phí',
    RelativeIndependent: 'Đơn vị SNCL tự chủ một phần chi thường xuyên',
    Depedent: 'Đơn vị SNCL do NSNN cấp kinh phí',
    NormalExpenditureAndInvest: 'Đơn vị SNCL tự chủ chi thường xuyên và đầu tư',
    NormalExpenditure: 'Đơn vị SNCL tự chủ chi thường xuyên',
  },
  Particular: {
    General: 'Không chọn',
    Science: 'Đặc thù Bộ khoa học',
    Statistic: 'Đặc thù Tổng cục thống kê',
    VAAC_US_CDC: 'VAAC-US.CDC',
    NamDinh: 'Đặc thù Nam Định',
    DongNai: 'Đặc thù Đồng Nai',
    CompleteAutonomy: 'Đặc thù các đơn vị tự chủ hoàn toàn',
    SYTBacNinh: 'Đặc thù Sở y tế Bắc Ninh',
    BoLDTB_XH: 'Đặc thù Bộ Lao động - Thương binh và xã hội',
    DangAudit: 'Đặc thù Kế toán Đảng',
    StateAudit: 'Đặc thù Kiểm toán Nhà nước',
    SGDHaiDuong: 'Đặc thù Sở giáo dục Hải Dương',
    STCLongAn: 'Đặc thù Sở tài chính Long An',
    BoTTTT: 'Đặc thù Bộ thông tin truyền thông',
    STCKhanhHoa: 'Đặc thù Sở tài chính Khánh Hòa',
  },
  TaxRate: {
    NoSelected: 'KCT',
    ZeroPercent: '0%',
    FivePercent: '5%',
    EightPercent: '8%',
    TenPercent: '10%',
  },
  TaxRateInventory: {
    NoSelected: 'KCT',
    ZeroPercent: '0%',
    FivePercent: '5%',
    EightPercent: '8%',
    TenPercent: '10%',
  },
  InvType: {
    // Loại Hóa đơn
    NoInvoice: 'Không có hóa đơn',
    NormalInvoice: 'Hóa đơn thông thường',
    InvoiceGTGT: 'Hóa đơn GTGT',
  },
  GovSource: {
    General: 'Không chọn',
    DomesticExpenditure: 'Nguồn chi từ vốn trong nước',
    ForeignExpenditure: 'Nguồn chi từ vốn ngoài nước',
  },
  BudgetItemType: {
    Group: 'Nhóm',
    SubGroup: 'Tiểu nhóm',
    Item: 'Mục',
    SubItem: 'Tiểu mục',
    SubSection: 'Tiết tiểu mục',
  },
  AccountTransferBusinessType: {
    // BalanceTransferYear: 'Kết chuyển số dư cuối năm',
    // PerformanceResultDefined: 'Xác định kết quả hoạt động',
    ReceiptWrite: 'Ghi thu',
    PaymentWrite: 'Ghi chi',
    Advance: 'Thanh toán tạm ứng',
    TranferClosing: 'Kết chuyển cuối năm',
    TranferReceiptClear: 'Kết chuyển thu, chi ngân sách xã',
    TranferReceiptClearInMonth13: 'Kết chuyển thu, chi ngân sách xã trong thời gian chỉnh lý',
    TransferBegining: 'Quyết toán dự toán chi ngân sách cuối năm',
    TransferActivity: 'Hoạt động sự nghiệp',
    TransferBudgetBalance: 'Kết chuyển kết dư sang thu ngân sách xã',
    TransferExtraBudget: 'Kết chuyển kết dư ngân sách xã',
    TransferExtraBudgetInMonth13: 'Kết chuyển kết dư ngân sách xã trong thời gian chỉnh lý',
    AdvancePaymentInMonth13: 'Thanh toán tạm ứng trong thời gian chỉnh lý',
  },
  ProjectType: {
    IntermAccountingUnitSt: 'Đơn vị kế toán trung gian 1',
    IntermAccountingUnitNd: 'Đơn vị kế toán trung gian 2',
    EstimatedUnitsSt: 'Đơn vị dự toán cấp 1',
    OutEstimatedUnitsStInProv: 'Ngoài đơn vị dự toán cấp 1 - trong cùng 1 tỉnh',
    OutEstimatedUnitsStDiffProv:
      'Ngoài đơn vị dự toán cấp 1 (khác tỉnh, khác Bộ, ngành) - trong lĩnh vực kế toán nhà nước',
    OutGovernmArea: 'Ngoài khu vực nhà nước',
  },
  AccountTransferTransferSide: {
    InDebt: 'Nợ',
    Yes: 'Có',
    BothSides: 'Hai bên',
  },
  ExecuteAction: {
    NoAction: 'Không xử lý',
    Inward: 'Nhập kho',
    Outward: 'Xuất kho',
  },

  SourceName: {
    Domestic: 'Nguồn ngân sách trong nước',
    Aid: 'Nguồn viện trợ',
    ForeignDebt: 'Nguồn vay nợ nước ngoài',
    FeeLeave: 'Nguồn phí được khấu trừ, để lại',
    OtherLeave: 'Nguồn hoạt động khác được để lại',
  },
  ReasonDecreaseFinalSettlement: {
    SubmitedStateBudget: 'Đã nộp NSNN',
    ToPayStateBudget: 'Còn phải nộp NSNN',
    CancelEstimate: 'Dự toán bị hủy',
  },
  OutwardPurpose: {
    OutwardUsed: 'Xuất dùng',
    OutwardSale: 'Xuất bán',
    OutwardOther: 'Xuất khác',
  },
  InOutwardPurpose: {
    OutwardUsed: 'Xuất dùng',
    OutwardOther: 'Xuất khác',
  },
  BudgetSourceKindType: {
    ActivityFund: 'Kinh phí hoạt động',
    RegularFund: 'Kinh phí thường xuyên',
    IrregularFund: 'Kinh phí không thường xuyên',
    ProjectFund: 'Kinh phí dự án',
    OrderPublicFund: 'Kinh phí theo đơn đặt hàng nhà nước',
    BasicConstructFund: 'Kinh phí đầu tư xây dựng cơ bản',
    InvestmentFund: 'Kinh phí tổng điều tra',
    PriorityFund: 'Kinh phí ưu đãi người có công',
    NotReturnFund: 'Kinh phí viện trợ không hoàn lại',
    DebtForeignFund: 'Kinh phí vay nợ nước ngoài',
  },
  BudgetSourceKindN01a: {
    RegularFund: 'Kinh phí thường xuyên',
    IrregularFund: 'Kinh phí không thường xuyên',
    BasicConstructFund: 'Kinh phí đầu tư xây dựng cơ bản',
    NotReturnFund: 'Kinh phí viện trợ không hoàn lại',
    DebtForeignFund: 'Kinh phí vay nợ nước ngoài',
  },

  BudgetFeesType: {
    Fee: 'Phí',
    Fees: 'Lệ phí',
  },
  InvoiceFormNumberType: {
    VatInvoice: 'Hóa đơn giá trị gia tăng',
    Bill: 'Hóa đơn bán hàng',
    DeliveryBillFreight: 'Phiếu xuất kho kiêm vận chuyển hàng hóa nội bộ',
    DeliveryBillAgentSales: 'Phiếu xuất kho gửi bán hàng đại lý',
    ExportBill: 'Hóa đơn xuất khẩu',
    BillOfSale: 'Hóa đơn bán hàng (dành cho tổ chức, cá nhân trong khu phi thuế quan)',
    ElecInvoicePublicProperty: 'Hóa đơn điện tử bán tài sản công',
    ElecInvoiceNationalReserves: 'Hóa đơn điện tử bán hàng dự trữ quốc gia',
    DiffBills: 'Hóa đơn khác (tem, vé, thẻ...)',
    Documents: 'Chứng từ như hóa đơn (PXK kiêm vận chuyển nội bộ, PXK hàng gửi bán đại lý)',
  },
  ReportPeriod: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: 'Sáu tháng đầu năm',
    SecondHalfYear: 'Sáu tháng cuối năm',
    Year: 'Cả năm',
    ThisMonth: 'Tháng này',
    ThisQuarter: 'Quý này',
    Custom: 'Tùy chọn',
  },
  ReportPeriodDcsdCustom: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    QuaterAll: 'Tất cả các quý',
    FirtsHalfYear: 'Sáu tháng đầu năm',
    SecondHalfYear: 'Sáu tháng cuối năm',
    Year: 'Cả năm',
    ThisMonth: 'Tháng này',
    ThisQuarter: 'Quý này',
    Custom: 'Tùy chọn',
  },
  Sheet: {
    Sheet1: 'Sheet 1',
    Sheet2: 'Sheet 2',
    Sheet3: 'Sheet 3',
    Sheet4: 'Sheet 4',
    Sheet5: 'Sheet 5',
    Sheet6: 'Sheet 6',
  },
  ReportPeriodSettlement: {
    Year: 'Cả năm',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
  },
  ReportPeriodCustom: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần đến hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng đến hiện tại',
    ThisQuarter: 'Quý này',
    FirstQuarterToPresent: 'Đầu quý đến hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm đến hiện tại',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý I',
    FiscalII: 'Quý II',
    FiscalIII: 'Quý III',
    FiscalIV: 'Quý IV',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    NextWeek: 'Tuần sau',
    Next4Week: 'Bốn tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tùy chọn',
  },
  InvoiceForm: {
    SeftPrintInvoice: 'Hóa đơn tự in',
    OrderPrintInvoice: 'Hóa đơn đặt in',
    ElectronicInvoice: 'Hóa đơn điện tử',
  },
  /**
   * Loại hợp đồng
   */
  ContractType: {
    Purchase: 'Hợp đồng mua',
    Sale: 'Hợp đồng bán',
    General: 'Không chọn',
  },
  StateImplement: {
    Stage: 'Theo giai đoạn',
    Annualy: 'Hàng năm',
  },
  ObjectType: {
    // Target: 'Chương trình mục tiêu',
    // Project: 'Dự án',
    Construction: 'Công trình',
    WorkItem: 'Hạng mục công trình',
  },
  TypeEstimate: {
    FirstOfYear: 'Đầu năm',
    Addition: 'Bổ sung',
  },
  ReportCre: {
    MonthDecember: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
    Year: 'Cả năm',
  },
  AutoBusinessType: {
    Auto: 'Mặc định',
    SelfSetting: 'Tự thiết lập',
  },
  /**
   * Giai đoạn đầu tư
   */
  InvestmentPeriod: {
    PrepareInvest: 'Giai đoạn chuẩn bị đầu tư',
    PerformInvest: 'Giai đoạn thực hiện đầu tư',
    EndInvest: 'Giai đoạn kết thúc xây dựng, đưa dự án vào khai thác sử dụng',
    Costs: 'Chi phí Ban quản lý dự án',
  },
  /**
   * Hình thức sổ kế toán
   */
  AccountingForm: {
    // Summary: 'Tổng hợp',
    SharedDiary: 'Nhật ký chung',
    LedgerDiary: 'Nhật ký - sổ cái',
    LicenseRecord: 'Chứng từ ghi sổ',
  },
  /**
   * Kí hiệu tiền tệ
   */
  MoneySign: {
    NormalVND: 'đ',
    UpperCaseVND: 'Đ',
    None: 'Không chọn',
  },
  /**
   * Ký tự ngăn cách
   */
  Separator: {
    Dot: '. (dấu chấm)',
    Comma: ', (dấu phẩy)',
  },
  /**
   * Định dạng số dương
   */
  PositiveFormat: {
    $n: '$n',
    '$ n': '$ n',
    n$: 'n$',
    'n $': 'n $',
  },
  /**
   * Định dạng số âm
   */
  NegativeFormat: {
    '($n)': '($n)',
    '-$n': '-$n',
    '$-n': '$-n',
    '$n-': '$n-',
    '(n$)': '(n$)',
    '-n $': '-n $',
    'n-$': 'n-$',
    'n $-': 'n $-',
    '-$ n': '-$ n',
    '$ n-': '$ n-',
    'n- $': 'n- $',
    '($ n)': '($ n)',
    '(n $)': '(n $)',
    '-n$': '-n$',
    'n$-': 'n$-',
  },
  /**
   * Hệ thống tùy chỉnh ngầm định nghiệp vụ
   */
  DefaultConfigBusiness: {
    None: 'Không chọn',

    AdvanceDistributed: 'Tạm ứng đã cấp dự toán',

    AdvanceUndistributed: 'Tạm ứng chưa cấp dự toán',

    AdvancePayment: 'Thanh toán tạm ứng',

    Expense: 'Thực chi',

    PlanReceipt: 'Nhận dự toán',

    TreasuryWarrantReceipt: 'Nhận lệnh chi tạm ứng',

    ReceiptExpense: 'Ghi thu, ghi chi',

    TreasuryWarrantReceiptExpense: 'Nhận lệnh chi thực chi',

    ExpenseReduce: 'Giảm chi - Thực chi',

    ExpenseReduceAdvance: 'Giảm chi - Tạm ứng',

    RefundExpense: 'Nộp trả - Thực chi',

    RefundAdvance: 'Nộp trả - Tạm ứng',

    Supplement: 'Bổ sung',

    RestoreExpense: 'Nộp phục hồi - Thực chi',

    RestoreAdvance: 'Nộp phục hồi - Tạm ứng',

    BudgetRejecttion: 'Xuất toán',

    ReceiptBudgetReturn: 'Giảm thu',

    IncrementAdjustment: 'Điều chỉnh tăng thuế GTGT',

    DecrementAdjustment: 'Điều chỉnh giảm thuế GTGT',

    DestroyPlanning: 'Hủy dự toán',

    BUPlanAdjustment: 'Điều chỉnh dự toán',

    DestroyReceipt: 'Hủy lệnh chi tiền',

    ReceiptForInferior: 'Lệnh chi cấp cho cấp dưới',

    ReceivedReceiptFromSuperiors: 'Lệnh chi nhận từ cấp trên',
  },
  /**
   * Hình thức cấp phát
   */
  AllocationFormat: {
    Budget: 'Dự toán',

    TreasuryWarrant: 'Lệnh chi',

    InKind: 'Hiện vật',

    RecordReceiptExpense: 'Ghi thu - Ghi chi',

    Other: 'Khác',
  },
  /**
   * Kí hiệu âm
   */
  NegativeSign: {
    '(n)': '(n)',
    '-n': '-n',
    '- n': '- n',
    'n-': 'n-',
    'n -': 'n -',
  },
  /**
   * Font chữ
   */
  FontFamily: {
    TimesNewRoman: 'Times New Roman',
    OpenSan: 'Open San',
    Arial: 'Arial',
    Tahoma: 'Tahoma',
    Cambria: 'Cambria',
    ArialNarrow: 'Arial Narrow',
  },
  /**
   * Kiểu chữ
   */
  FontStyle: {
    Regular: 'Regular',
    Bold: 'Bold',
    Italic: 'Italic',
    BoldItalic: 'Bold Italic',
  },
  /**
   *Ghi chú - thiết lập quy tắc hạch toán đồng thời
   */
  SignType: {
    Record: 'Ghi âm',
    Positive: 'Ghi dương',
  },

  /**
   *Ghi chú - thiết lập quy tắc hạch toán đồng thời
   */
  StatisticType: {
    OtherXDCB: 'Để trống hoặc chọn khác MISACHI_XDCB',
    IsXDCB: 'MISACHI_XDCB',
  },

  /**
   * Công thức âm dương
   */
  SignFormula: {
    Negative: '-',
    Positive: '+',
  },
  /**
   * Tính chất nguồn
   */
  BudgetSourceGroupPropertyType: {
    NotSelected: 'Không chọn',
    Regular: 'Thường xuyên',
    IRegular: 'Không thường xuyên',
  },
  /**
   * Tỉnh/thành phố
   */
  Province: {
    HaNoi: 'Hà Nội',
    HoChiMinh: 'Hồ Chí Minh',
    DaNang: 'Đà Nẵng',
    CanTho: 'Cần Thơ',
  },

  InventoryCategoryCode: {
    CCCD: 'Công cụ dụng cụ',
    VT: 'Vật tư',
  },
  /**
   * Xuất gửi cho
   */
  ExportFor: {
    SendTreasury: 'Xuất khẩu gửi kho bạc nhà nước',
    SendTaxAuthorities: 'Xuất khẩu gửi cơ quan thuế',
  },

  ReportID: {
    // Báo cáo tài chính
    BCTC01: 'BCTC-01',
    BCTC02: 'BCTC-02',
    BCTC03b: 'BCTC-03b',
    BCTC03a: 'BCTC-03a',
    BCTC04: 'BCTC-04',
    BCTC05: 'BCTC-05',
    BCTCExport04: 'BCTCExport-04',
    BCTC01bstt: 'BCTC-01bstt',

    // Báo cáo quyết toán
    BCQT02: 'BCQT-02',
    BCQT03: 'BCQT-03',

    BCQT03TCTK: 'BCQT-TCTK-03',
    // Báo cáo thực hiện xử lý kiến nghị của kiểm toán, thanh tra, tài chính
    B02_BCQT: 'B02_BCQT',

    // Báo cáo chứng từ
    DNTTV04a: 'DNTTV04a',
    FixedAssetTag: 'FixedAssetTag',

    // Báo cáo kho bạc
    S104H: 'S104H',
    // Sổ chi tiết theo dõi số liệu quyết toán
    S105H1: 'S105H1',

    // Sổ chi tiết theo dõi số liệu quyết toán
    S106H1: 'S106H1',

    // Báo cáo S105-H Phần 2: Sổ theo dõi nguồn phí khấu trừ, được để lại (Phần II)
    S105_H_2: 'S105H2',

    // Báo cáo S106-H Phần 2: Sổ theo dõi nguồn thu hoạt động khác để lại (Phần II)
    S106_H_2: 'S106H2',

    S13H: 'S13H',
    // Sổ đăng ký chứng từ ghi sổ
    S02bH: 'S02b-H',
    S101H1: 'S101H1',

    // Báo cáo vật tư hàng hóa
    S21H: 'S21-H',
    S22H: 'S22-H',
    S23H: 'S23-H',

    // Báo cáo tồn kho
    InventoryBookMaster: 'InventoryBookMaster',
    InventoryBook_ToAmount: 'InventoryBook_ToAmount',
    //  báo cáo Sổ chi tiết bán hàng
    SaleDetail: 'SaleDetail',
    // Phiếu điều chỉnh số liệu ngân sách (Thông tư số 19/2020/TT-BTC)
    BCC210NSTT19: '652_C2_10NS_TT19',

    // Báo cáo đồi chiếu kho bạc
    CashInBankConfirmation: 'CashInBankConfirmation',
    S12H: 'S12-H',
    S11H: 'S11-H-Report',
    B02_TT90_2018: 'B02_TT90_2018',
    // Báo cáo sổ chi tiết mua hàng
    PurchaseDetailBook: 'PurchaseDetailBook',
    // mẫu S02c-H: Sổ cái - Hình thức chứng từ ghi sổ (PBI 59376)
    S02C_H: 'S02c-H',
    B01_BCQT: '01_BCQT',
    B01_BCQT_KTNN: '01_BCQT_KTNN',
    B04_BCQT_KTNN: 'B04_BCQT_KTNN',
    // Mẫu Sổ cái - Mục lục ngân sách
    S03_H_Budget: 'S03-H-Budget',
    // Phụ biểu F01-01/BCQT: Báo cáo chi tiết chi từ nguồn NSNN và nguồn phí được khấu trừ, để lại
    B01_01_BCQT_Master: '01_01_BCQT_Master',
    // Báo cáo Sổ tổng hợp tài khoản
    GLSummaryAccount: 'GLSummaryAccount',

    // Phụ biểu F01-02/BCQT: Báo cáo chi tiết kinh phí chương trình, dự án
    F01_02_BCQT_P2: 'F01_02_BCQT',
    F01_02_BCQTP1: 'F01_02_BCQT_P1', // phần 1 của bc F01_02
    F01_02_BCQTP2: 'F01_02_BCQT_P2', // phần 2 của bc F01_02

    // Thuyết minh B01/BSTT báo cáo bổ sung thông tin tài chính
    B01_BSTT_TM: 'B01_BSTT_TM',

    // S04-H: Sổ nhật ký chung
    S04_H: 'S04-H',
    // bqdiep 07/12/2022: cập nhật thêm báo cáo S34-H; S34-H: Sổ chi tiết thanh toán với khách hàng
    S34_H: 'S34-H',
    // Báo cáo S101-H Phần 2: Sổ tổng hợp theo dõi dự toán từ nguồn NSNN trong nước
    S101_H_2: 'S101H2',
    // Báo cáo S02a-H: Chứng từ ghi sổ
    S02a_H: 'S02a-H',

    // Báo cáo Đối chiếu kho bạc
    N01a_SDKP_DVDT: 'N01a_SDKP_DVDT',
    N01b_SDKP_DVDT: 'N01b_SDKP_DVDT',
    N02a_SDKP_DVDT: 'N02a_SDKP_DVDT',
    N02b_SDKP_DVDT: 'N02b_SDKP_DVDT',
    // Sổ nhật ký mua hàng
    PurchaseDiary: 'PurchaseDiary',
    // S62-H: Sổ chi phí sản xuất, kinh doanh (Hoặc đầu tư XDCB)
    S62_H: 'S62-H',

    // Sổ chi tiết công nợ phải thu
    LiabilityObjectMonitor: 'LiabilityObjectMonitor',
    // báo cáo tổng hợp công nợ phải thu
    SummaryReceivable: 'SummaryReceivable',

    // InventoryInStockByBatch : Báo cáo tồn kho theo lô
    InventoryInStockByBatch: 'InventoryInStockByBatch',
    // Báo cáo tồn kho theo theo chứng từ nhập
    InventoryInStockByInward: 'InventoryInStockByInward',
    // Báo cáo tổng hợp công nợ
    SummaryOther: 'SummaryOther',
    // Báo cáo Số theo dõi tạm ứng
    AdvanceTracking: 'AdvanceTracking',
    // Báo cáo Sổ cái tài khoản nhóm theo đối ứng
    GeneralLedgerCorresponding: 'GeneralLedgerCorresponding',
    // Báo số dư các chi tiết của 1 tài khoản
    AccountDetailBalance: 'AccountDetailBalance',
    // Báo cáo đối chiếu hạch toán tài chính và hạch toán ngoài bảng
    ComparisonReportParalell: 'ComparisonReportParalell',
    // Báo số tổng hợp tình hình kinh phí dự án
    SummaryProjectExpense: 'SummaryProjectExpense',
    S24H: 'S24H',
    // Báo cáo đối chiếu kinh phí rút và chi theo MLNS
    F02_01H_QD19: 'F02_01H_QD19',
    // S52-H: Sổ chi tiết các khoản tạm thu
    S52H: 'S52H',
    // SummaryPayable : Tổng hợp công nợ phải trả
    SummaryPayable: 'SummaryPayable',
    // Biểu số 58 - Phụ lục tổng hợp đối chiếu tại KBNN nơi giao dịch
    ReportParam_B58_KTNNNew: 'ReportParam_B58_KTNNNew',

    ReportSaleVoucherCompare: 'ReportSaleVoucherCompare',
    MinutesInventoryFixedAsset: 'MinutesInventoryFixedAsset',

    // C55-HD: Bảng tính hao mòn tài sản
    AttritionCaculateBook: 'AttritionCaculateBook',
    // Báo cáo Mấu số 07 - Phiếu xuất kho
    42_11: '42.11',
    42_11_214: '42.11_214',
    42_11_212: '42.11_212',
    // Báo cáo Quyết toán tổng hợp nhập xuất tồn
    GeneralImportExportReserveSettlement: 'GeneralImportExportReserveSettlement',
    // Báo cáo Vật tư hàng hóa tồn kho đầu năm
    InventoryItemBeginYearOpenning: 'InventoryItemBeginYearOpenning',

    // S26-H: Sổ theo dõi công cụ, dụng cụ tại nơi sử dụng
    S26H: 'S26HSupply',

    // Báo cáo kiểm kê tài sản cố định
    InventoryFixedAsset: 'InventoryFixedAsset',

    // Báo cáo tăng giảm tài sản cố định
    UpDownFixedAsset: 'B04-H-01',
    // S05H: Bảng cân đối phát sinh các tài khoản
    S05H: 'S05H',

    // Báo cáo kiểm kê TSCĐ mẫu phòng ban
    InventoryFixedAsset_Department: 'InventoryFixedAsset_Department',
    // [BC] Báo cáo chênh lệch thu, chi theo hoạt động SXKD, dịch vụ
    DifferenceReceiptExpenseByActivity: 'DifferenceReceiptExpenseByActivity',
    // VoucherListByStatisticsCode: Liệt kê chứng từ kế toán theo mã thống kê
    VoucherListByStatisticsCode: 'VoucherListByStatisticsCode',
    // B58_KTNN: Phụ lục tổng hợp đối chiếu tại KBNN
    B58_KTNN: 'B58_KTNN',
    // BC F01_01/BCTC đặc thù hải dương
    F0101BCQTHD: '01_01_BCQT_HD',
  },
  /**
   * Loại công thức
   */
  ColumnDataType: {
    // Hệ số
    Coefficient: 'Hệ số',
    // Tỷ lệ
    Rate: 'Tỷ lệ',
    // Khác
    Other: 'Khác',
  },
  /**
   * Loại Nộp kinh phí
   */
  UnionInsurance: {
    // Bảo hiểm
    Insurance: 'Bảo hiểm',
    // KPCĐ
    LaborUnion: 'Kinh phí công đoàn',
  },

  /**
   * Tính số nộp kỳ này
   */
  CalculatePay: {
    // Bảo hiểm
    All: 'Trên toàn bộ số phát sinh',
    // KPCĐ
    ExcludeInsurance: 'Sau khi trừ bảo hiểm trả thay lương',
  },

  /**
   *Loại khoản lương
   */
  PayrollItemType: {
    // Thu nhập thường xuyên
    IncomRecurrent: 'Thu nhập thường xuyên',
    // Thu nhập không thường xuyên
    IncomCasual: 'Thu nhập không thường xuyên',
    // Khấu trừ thường xuyên
    OutcomRecurrent: 'Khấu trừ thường xuyên',
    // Khấu trừ không thường xuyên
    OutcomCasual: 'Khấu trừ không thường xuyên',
  },

  /**
   *Loại khoản lương
   */
  PayrollItemColumnType: {
    // Thu nhập thường xuyên
    IncomRecurrent: 'Thu nhập thường xuyên',
    // Thu nhập không thường xuyên
    IncomCasual: 'Thu nhập không thường xuyên',
    // Khấu trừ thường xuyên
    OutcomRecurrent: 'Khấu trừ thường xuyên',
    // Khấu trừ không thường xuyên
    OutcomCasual: 'Khấu trừ không thường xuyên',
    Timekeeping: 'Chấm công',
    SalaryRule: 'Quy định lương, thuế, báo hiểm',
  },

  /**
   * Hình thức hóa đơn
   */
  PayForm: {
    Cash: 'TM', // Tiền mặt
    Transfer: 'CK', // Chuyển khoản
    Undefined: 'TM/CK', // Chưa xác định được hình thức thanh toán
  },

  /**
   * Mã lỗi Validate
   */
  ValidateCode: {
    Required: 'Nhập thiếu thông tin',
    EditVersion: 'Dữ liệu đã bị thay đổi bởi người dùng khác',
    Duplicate: 'Dữ liệu đã tồn tại trong hệ thống',
    Arise: 'Danh mục đã có phát sinh',
    System: 'Dữ liệu thuộc hệ thống',
    StartWithOther: 'Phần đầu trùng với số hiệu của cài khoản con cùng cấp',
  },

  MessageBoxType: {
    confirm_Info_Warning: 0,
    confirm_Yes_No: 1,
    confirm_Yes_No_Cancel: 2,
    confirm_Delete: 3,
    confirm_Close: 4,
  },

  /**
   * RefType danh mục
   * bnanh 04.07.2022
   */
  RefTypeDictionary: {
    CustomerVendor: 1, // Khách hàng, nhà cung cấp
    Employee: 2, // Cán bộ
  },

  /**
   * Enum Ngừng theo dõi
   * NVTUAN1 07.07.2022
   */
  Inactive: {
    All: 'Tất cả',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
  },

  /**
   * Enum Dùng công thức
   */
  UseFormula: {
    Use: 'Có công thức',
    None: 'Không có công thức',
  },

  /**
   * Enum xử lý ở điều chỉnh tồn kho
   * NVTOAN2 09/07/2022
   */
  Execute: {
    All: 'Tất cả',
    Excuted: 'Đã xử lý',
    NotExcute: 'Chưa xử lý',
  },

  /**
   * Enum Ngừng theo dõi
   * NVTOAN2 09/07/2022
   */
  TreasuryApprove: {
    All: 'Tất cả',
    Paid: 'Đã thanh toán',
    UnPaid: 'Chưa thanh toán',
  },

  /**
   * Enum Theo dõi
   * tvhien 01.08.2022
   */
  Active: {
    All: 'Tất cả',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
  },

  /**
   * Enum ghi sổ
   * HQMINH 12.07.2022
   */
  PostedType: {
    All: 'Tất cả',
    NotPosted: 'Chưa ghi sổ',
    Posted: 'Đã ghi sổ',
  },

  /**
   * Enum trạng thái lập biên lai
   * TVTOAN 03.07.2023
   */
  ReceiptStatusType: {
    NotCreateReceipt: 'Đã lập biên lai',
    CreateReceipt: 'Chưa lập biên lai',
  },

  /**
   * Enum Tính thuế
   * TVDAT 12.07.2022
   */
  IsPersonalIncomeTax: {
    All: 'Tất cả',
    IsPersonalIncomeTax: 'Tính thuế',
    NotIsPersonalIncomeTax: 'Không tính thuế',
  },
  /**
   * Enum Tính BHXH
   * TVDAT 12.07.2022
   */
  IsSocialInsurance: {
    All: 'Tất cả',
    IsSocialInsurance: 'Tính BHXH',
    NotIsSocialInsurance: 'Không tính BHXH',
  },
  /**
   * Enum Tính BHYT
   * TVDAT 12.07.2022
   */
  IsHealthInsurance: {
    All: 'Tất cả',
    IsHealthInsurance: 'Tính BHYT',
    NotIsHealthInsurance: 'Không tính BHYT',
  },
  /**
   * Enum Tính BHTN
   * TVDAT 12.07.2022
   */
  IsUnemploymentInsurance: {
    All: 'Tất cả',
    IsUnemploymentInsurance: 'Tính BHTN',
    NotIsUnemploymentInsurance: 'Không tính BHTN',
  },
  /**
   * Enum Tính KPCĐ
   * TVDAT 12.07.2022
   */
  IsLaborUnion: {
    All: 'Tất cả',
    IsLaborUnion: 'Tính KPCĐ',
    NotIsLaborUnion: 'Không tính KPCĐ',
  },
  /**
   * Group ref type
   * NCPHUOC 12/07/2022
   */
  RefTypeGroup: {
    BUPlanReceipt: 'Nhận dự toán',
    BUTransfer: 'Chuyển khoản kho bạc',
  },

  /**
   * Trạng thái validate của dòng nhập khẩu
   * NCPHUOC 28/07/2022
   */
  ImportValidateStatus: {
    Valid: 'Hợp lệ',
    DataExist: 'Dữ liệu đã tồn tại',
    NotValid: 'Không hợp lệ',
  },

  /**
   * CTMT, DA
   * @author nnnam - 3/8/2022
   */
  ProjectObjectType: {
    Target: 'Chương trình mục tiêu',
    Project: 'Dự án',
    Construction: 'Công trình',
    WorkItem: 'Hạng mục công trình',
  },
  /* Enum đã lập hóa đơn
   * HQMINH 02.08.2022
   */
  Invoiced: {
    All: 'Tất cả',
    NotInvoiced: 'Chưa lập hóa đơn',
    Invoiced: 'Đã lập hóa đơn',
  },

  /**
   * Enum thu nhập không thường xuyên
   * vqphong - 15/12/2022
   */
  OtherIncome: {
    All: 'Tất cả',
    PayWithSalary: 'Có trả cùng lương',
    NotPayWithSalary: 'Không trả cùng lương',
  },

  /**
   * Enum khấu trừ không thường xuyên
   * vqphong - 15/12/2022
   */
  OtherOutcome: {
    All: 'Tất cả',
    PayWithSalary: 'Có trừ vào lương',
    NotPayWithSalary: 'Không trừ vào lương',
  },

  /**
   * Enum Phương pháp tính giá
   * NVTUAN1 12.08.2022
   */
  CostMethod: {
    // Bình quân cuối kỳ
    ClossingAverage: 0,
    // Bình quân tức thì
    ImmediateAverage: 1,
    // Đích danh
    RealName: 2,
    // Nhập trước xuất trước
    FirstInFirstOut: 3,
  },

  /**
   * Enum mẫu báo cáo
   * dqdat1 16.08.2022
   */
  ReportParamType: {
    ND11_2020: 'Nghị định 11/2020/NĐ-CP',
    DongThap: 'Đặc thù Đồng Tháp',
  },

  ReportParamTypeBudgetItem: {
    F01_01_BCQT: 'Mẫu thông tư số 107/2017/TT-BTC',
    F01_01_BCQT_BudgetItemDetail: 'Mẫu tiết tiểu mục',
  },

  ReportParamTypeF0101BCQT: {
    F01_01_BCQT: 'Mẫu thông tư số 107/2017/TT-BTC',
  },

  ReportParamTypeN01aSDKPDVDTND112020: {
    N01a_SDKP_DVDT_ND112020: 'Nghị định 11/2020/NĐ-CP',
    N01a_SDKP_DVDT_ND112020_Dynamic: 'Nghị định 11/2020/NĐ-CP (Mẫu tùy chỉnh)',
  },

  ReportParamTypeN01bSDKPDVDTND112020: {
    N01b_SDKP_DVDT_ND112020: 'Nghị định 11/2020/NĐ-CP',
  },

  ReportParamTypeN02aSDKPDVDTND112020: {
    N02a_SDKP_DVDT_ND112020_Update: 'Thông tư 18/2020/TT-BTC',
    N02a_SDKP_DVDT_ND112020_UpdateDynamic: 'Thông tư 18/2020/TT-BTC (Mẫu tùy chỉnh)',
    N02a_SDKP_DVDT_ND112020: 'Nghị định 11/2020/NĐ-CP',
    N02a_SDKP_DVDT_Dynamic_ND112020: 'Nghị định 11/2020/NĐ-CP (Mẫu tùy chỉnh)',
  },

  ReportParamTypeN02bSDKPDVDTND112020: {
    N02b_SDKP_DVDT_ND112020: 'Nghị định 11/2020/NĐ-CP',
  },

  ReportParamTypeS22H: {
    S22_H_QD19: 'Thông tư 107/2017/TT-BTC',
  },

  ReportParamTypeCDTB03: {
    A4_Vertical: 'Mẫu A4 dọc',
    A4_Horizontal: 'Mẫu A4 ngang',
  },

  ReportParamTypeCDTF03C: {
    A4_Vertical: 'Mẫu A4 dọc',
    A4_Horizontal: 'Mẫu A4 ngang',
  },

  /**
   * Enum Nghiệp vụ trong form in chứng từ mẫu 05/TT
   * TTLONG 11/08/2022
   */
  Major: {
    Expense: 'Thực chi',
    Advance: 'Tạm ứng',
    AdvanceIsNotEligibleForPayment: 'Ứng trước chưa đủ điều kiện thanh toán',
    AdvanceIsEligibleForPayment: 'Ứng trước đủ điều kiện thanh toán',
    None: 'Không chọn',
  },
  /**
   * Enum Hình thức thanh toán trong form in chứng từ mẫu 05/TT
   * TTLONG 11/08/2022
   */
  PaymentFormality: {
    Transfer: 'Chuyển khoản',
    CashAtKB: 'Tiền mặt tại KB',
    CashAtNH: 'Tiền mặt tại NH',
    None: 'Không chọn',
  },

  PaymentFormality_Tooltip: {
    Transfer: 'Chuyển khoản',
    CashAtKB: 'Tiền mặt tại kho bạc',
    CashAtNH: 'Tiền mặt tại ngân hàng',
    None: 'Không chọn',
  },

  /** enum mẫu báo cáo S11H - Sổ kế toán tiền mặt*/
  S11HReportType: {
    defaultType: 'Mẫu quản trị',
    TT107: 'Mẫu thông tư số 107/2017/TT-BTC',
  },
  /*
   * Enum nghiệp vụ báo cáo
   */
  ReportCashWithDrawType: {
    PaymentAdvance: 'Tạm ứng sang thực chi',
    EstimateAdvance: 'Ứng trước chưa đủ ĐKTT sang Ứng trước đủ ĐKTT',
    NotSelected: 'Không chọn',
  },
  /**
   * Enum kinh phí tạm ứng để thanh toán tạm ứng
   */
  ReportBudgetSourceKindType: {
    RegularFund: 'Kinh phí đã cấp dự toán hoạt động thường xuyên',
    IrregularFund: 'Kinh phí đã cấp dự toán hoạt động không thường xuyên',
    ProjectFund: 'Kinh phí đầu tư XDCB',
  },
  /**
   * Enum mẫu báo cáo S21-H: Sổ kho
   * NCQUYEN 16/08/2022
   */
  S21HReportType: {
    TT107: 'Thông tư 107/2017/TT-BTC',
    CompositeSample: 'Mẫu tổng hợp',
  },

  InventoryBookMasterReportType: {
    InventoryBookMaster: 'Mẫu báo cáo tồn kho',
    InventoryBookMasterAverage: 'Mẫu hiển thị đơn giá nhập bình quân',
  },

  /**
   *  Enum cấp
   * ndhieu3 19.04.2023
   */
  Kind: {
    Province: 'Tỉnh/Thành phố',
    District: 'Quận/Huyện',
    Ward: 'Xã/Phường',
  },
  /**
   * Enum mẫu báo cáo S61-H: Sổ chi tiết chi phí
   * lttuan1 10/10/2022
   */
  S61HReportType: {
    TT107: 'Mẫu theo Thông tư 107/2017/TT-BTC',
    TM: 'Mẫu chi tiết theo tiểu mục',
    TTM: 'Mẫu chi tiết theo tiết tiểu mục',
  },

  /**
   * Enum mẫu Báo cáo tình hình tăng giảm CCDC
   * lttuan1 09.12.2022
   */
  SupplyIncreaseDecreaseReportType: {
    Detail: 'Mẫu in chi tiết',
    Summary: 'Mẫu in tổng hợp',
  },

  /**
   * Enum mẫu báo cáo S01-H: Sổ chi tiết chi phí
   * lttuan1 10/10/2022
   */
  S01HReportType: {
    A4: 'Mẫu TT107/2017/TT-BTC - Khổ A4',
    A3: 'Mẫu TT107/2017/TT-BTC - Khổ A3',
  },

  /**
   * Mã check tk có bắt đầu bằng 111 thì cho phép in chứng từ
   * TPNAM 28.08.2022
   */
  C4HDTCType: {
    StartWidth111: '111',
  },
  /**
   * Đơn vị tính
   * pt hai 31/08/2022
   */
  UnitMoney: {
    One: 'Đồng',
    OneThousand: 'Nghìn đồng',
    OneMillion: 'Triệu đồng',
    OneBillion: 'Tỷ đồng',
  },

  /**
   * Trạng thái hóa đơn
   * tvhien 31.08.2022
   */
  SaleInvoiceStateType: {
    SaleInvoice: 'HĐ gốc',
    SaleInvoiceReplace: 'HĐ thay thế',
    SaleInvoiceAdjustment: 'HĐ điều chỉnh',
    SaleInvoiceCancel: 'HĐ hủy',
  },

  /**
   * Trạng thái phát hành khi không có mã cơ quan thuế
   * tvhien 31.08.2022
   */
  SaleInvoiceStateReleaseType: {
    UnRelease: 'Chưa phát hành',
    IsReleased: 'Đang phát hành',
    Released: 'Đã phát hành',
    ReleaseError: 'Phát hành lỗi',
    NoSendTax: 'Chưa gửi cho CQT',
    SendTax: 'Đã gửi cho CQT',
    SaleInvoiceInValid: 'HĐ không hợp lệ',
  },

  /**
   * Trạng thái phát hành khi có mã cơ quan thuế
   * tvhien 16.09.2022
   */
  SaleInvoiceStateCQT: {
    UnRelease: 'Chưa phát hành',
    IsReleased: 'Đang phát hành',
    ReleaseError: 'Phát hành lỗi',
    NoSendTax: 'Chờ cấp mã',
    SendTax: 'Đã cấp mã',
    SaleInvoiceInValid: 'HĐ không hợp lệ',
    Rejected: 'Từ chối cấp mã',
  },

  /**
   * Trạng thái gửi hóa đơn
   * tvhien 16.09.2022
   */
  SendInvoiceStatus: {
    NoSend: 'Chưa gửi',
    SendWaiting: 'Chờ gửi',
    Send: 'Đã gửi',
  },

  /**
   * Nghị định để load hóa đơn
   */
  SaleInvoiceType: {
    Decree123: 'Nghị định 123/2020/NĐ-CP',
    Decree51: 'Nghị định 51/2010/NĐ-CP',
  },

  FormulaSign: {
    add: '+',
    subtract: '-',
    multiple: 'x',
    divide: '/',
  },

  // loại icon hiển thị tại msCellInput
  SuffixIconType: {
    More: 0,
    View: 1,
    Edit: 2,
  },

  ReportS05: {
    S05: 'Thông tư 107/2017/TT-BTC',
    S05_2Ben: 'Mẫu số dư hai bên',
  },

  /** Lũy kế phát sinh */
  AccumIncurred: {
    StartData: 'Ngày bắt đầu dữ liệu',
    StartYear: 'Ngày bắt đầu năm TC của kỳ báo cáo',
  },
  /**
   * đã hạch toán hay chưa
   */
  IsPosted: {
    All: 'Tất cả',
    UnPosted: 'Chưa hạch toán',
    Posted: 'Đã hạch toán',
  },

  /**
   * Đã ghi sổ hay chưa
   */
  IsPostedSearch: {
    UnPosted: 'Chưa ghi sổ',
    Posted: 'Đã ghi sổ',
  },

  IsTreasuryApproved: {
    NotApproved: 'Chưa duyệt',
    Approved: 'Đã duyệt',
  },

  SearchField: {
    ref_date: 'ref_date',
    ref_no: 'ref_no',
    ref_type: 'ref_type',
    posted_date: 'posted_date',
    inv_date: 'inv_date',
    inv_no: 'inv_no',
    debit_account: 'debit_account',
    credit_account: 'credit_account',
    amount: 'amount',
    budget_source_code: 'budget_source_code',
    budget_chapter_code: 'budget_chapter_code',
    budget_provide_code: 'budget_provide_code',
    budget_kind_item_code: 'budget_kind_item_code',
    budget_sub_kind_item_code: 'budget_sub_kind_item_code',
    method_distribute_type: 'method_distribute_type',
    budget_item_code: 'budget_item_code',
    budget_sub_item_code: 'budget_sub_item_code',
    accounting_object_code: 'accounting_object_code',
    inventory_item_code: 'inventory_item_code',
    inventory_item_tool_code: 'inventory_item_tool_code',
    quantity: 'quantity',
    stock_code: 'stock_code',
    description: 'description',
    activity_code: 'activity_code',
    cash_withdraw_type_id: 'cash_withdraw_type_id',
    fixed_asset_code: 'fixed_asset_code',
    project_code: 'project_code',
    fund_code: 'fund_code',
    department_code: 'department_code',
    statistic_code: 'statistic_code',
    is_treasury_approved: 'is_treasury_approved',
    approved_date: 'approved_date',
    debit_bank_account: 'debit_bank_account',
    credit_bank_account: 'credit_bank_account',
    bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
    budget_source_property_code: 'budget_source_property_code',
    budget_fees_code: 'budget_fees_code',
    contract_no: 'contract_no',
    contract_sell_no: 'contract_sell_no',
  },

  /**
   * Trạng thái hồ sơ đối chiếu trên KBNN
   */
  DCSDFileTreasuryStatus: {
    WaitKBNNStaff: 'Chờ GDV tiếp nhận hồ sơ',
    KBNNStaffReject: 'GDV từ chối tiếp nhận hồ sơ',
    KBNNStaffApprove: 'GDV đã tiếp nhận hồ sơ',
    WaitKBNNChief: 'Chờ trưởng phòng kiểm soát hồ sơ',
    KBNNChiefReject: 'Trưởng phòng từ chối kiểm soát hồ sơ',
    KBNNChiefApprove: 'Trưởng phòng đã phê duyệt hồ sơ',
    KBNNReject: 'KBNN từ chối xử lý hồ sơ',
  },

  DCSDFileTreasuryStatus_Tooltip: {
    WaitKBNNStaff: 'Chờ Giao dịch viên tiếp nhận hồ sơ',
    KBNNStaffReject: 'Giao dịch viên từ chối tiếp nhận hồ sơ',
    KBNNStaffApprove: 'Giao dịch viên đã tiếp nhận hồ sơ',
    WaitKBNNChief: 'Chờ trưởng phòng kiểm soát hồ sơ',
    KBNNChiefReject: 'Trưởng phòng từ chối kiểm soát hồ sơ',
    KBNNChiefApprove: 'Trưởng phòng đã phê duyệt hồ sơ',
    KBNNReject: 'KBNN từ chối xử lý hồ sơ',
  },

  /**
   * Trạng thái giao dịch (Kế toán trưởng)
   */
  FileStatus: {
    CompanyDirectorReject: 'Chủ tài khoản từ chối duyệt',
    CompanyChiefAccountantReject: 'Kế toán trưởng từ chối duyệt',
    Saved: 'Mới tạo',
    WaitChiefAccountantApproval: 'Chờ kế toán trưởng phê duyệt',
    WaitingCompanyDirector: 'Chờ chủ tài khoản duyệt',
    // CompanyDirectorApproved: 'Chủ tài khoản đã phê duyệt', //bỏ trạng thái chủ tài khoản đã duyệt-bug 61380-htthoa 12.12.2023
    FileNotSentToChiefAccountant: 'Chưa gửi duyệt',
    WaitKBNNReceipt: 'Chờ KBNN tiếp nhận hồ sơ',
    KBNNHandling: 'KBNN đang xử lý hồ sơ',
    KBNNChiefApprove: 'Đã được lãnh đạo KBNN phê duyệt',
    KBNNReject: 'KBNN từ chối xử lý hồ sơ',
    CompanyRemoveFile: 'Chủ tài khoản/UQ CTK đã xóa hồ sơ',
    KBNNInfoResult: 'KBNN thông báo kết quả xử lý thanh toán',
  },

  FileStatus_Tooltip: {
    CompanyDirectorReject: 'Chủ tài khoản từ chối duyệt',
    CompanyChiefAccountantReject: 'Kế toán trưởng từ chối duyệt',
    Saved: 'Mới tạo',
    WaitChiefAccountantApproval: 'Chờ kế toán trưởng phê duyệt',
    WaitingCompanyDirector: 'Chờ chủ tài khoản phê duyệt',
    CompanyDirectorApproved: 'Chủ tài khoản đã phê duyệt',
    FileNotSentToChiefAccountant: 'Chưa gửi duyệt',
    WaitKBNNReceipt: 'Chờ KBNN tiếp nhận hồ sơ',
    KBNNHandling: 'KBNN đang xử lý hồ sơ',
    KBNNChiefApprove: 'Đã được lãnh đạo KBNN phê duyệt',
    KBNNReject: 'KBNN từ chối xử lý hồ sơ',
  },

  /**
   * Trạng thái giao dịch (Kế toán viên)
   */
  FileStatusAccountant: {
    Waiting: 'Chờ KTT phê duyệt',
    FileNotSent: 'Chưa gửi duyệt',
    AccountApproved: 'Chủ tài khoản đã phê duyệt',
    TreasuryApproved: 'Đã được KBNN duyệt',
    AccountReject: 'Chủ tài khoản từ chối duyệt',
    WaitingTreasury: 'Chờ KBNN tiếp nhận hồ sơ',
    TreasuryHandling: 'KBNN đang xử lí hồ sơ',
    TreasuryReject: 'KBNN từ chối',
    CompanyDirectorReject: 'Chủ tài khoản từ chối duyệt',
    CompanyChiefAccountantReject: 'Kế toán trưởng từ chối duyệt',
    Saved: 'Mới tạo',
    WaitChiefAccountantApproval: 'Chờ kế toán trưởng phê duyệt',
    WaitingCompanyDirector: 'Chờ chủ tài khoản phê duyệt',
    CompanyDirectorApproved: 'Chủ tài khoản đã phê duyệt',
    FileNotSentToChiefAccountant: 'Chưa gửi duyệt',
    WaitKBNNReceipt: 'Chờ KBNN tiếp nhận hồ sơ',
    KBNNHandling: 'KBNN đang xử lý hồ sơ',
    KBNNChiefApprove: 'Đã được lãnh đạo KBNN phê duyệt',
    KBNNReject: 'KBNN từ chối xử lý hồ sơ',
  },

  FileStatusAccountant_Tooltip: {
    Waiting: 'Chờ KTT phê duyệt',
    FileNotSent: 'Chưa gửi duyệt',
    AccountApproved: 'Chủ tài khoản đã phê duyệt',
    TreasuryApproved: 'Đã được KBNN duyệt',
    AccountReject: 'Chủ tài khoản từ chối duyệt',
    WaitingTreasury: 'Chờ KBNN tiếp nhận hồ sơ',
    TreasuryHandling: 'KBNN đang xử lí hồ sơ',
    TreasuryReject: 'KBNN từ chối',
    CompanyDirectorReject: 'Chủ tài khoản từ chối duyệt',
    CompanyChiefAccountantReject: 'Kế toán trưởng từ chối duyệt',
    Saved: 'Mới tạo',
    WaitChiefAccountantApproval: 'Chờ kế toán trưởng phê duyệt',
    WaitingCompanyDirector: 'Chờ chủ tài khoản phê duyệt',
    CompanyDirectorApproved: 'Chủ tài khoản đã phê duyệt',
    FileNotSentToChiefAccountant: 'Chưa gửi duyệt',
    WaitKBNNReceipt: 'Chờ KBNN tiếp nhận hồ sơ',
    KBNNHandling: 'KBNN đang xử lý hồ sơ',
    KBNNChiefApprove: 'Đã được lãnh đạo KBNN phê duyệt',
    KBNNReject: 'KBNN từ chối xử lý hồ sơ',
  },

  /**
   * Một số title được dùng trong KBNN
   */
  DVCTitle: {
    SendToChiefAccountant: 'Gửi hồ sơ lên kế toán trưởng',
    SendToAccount: 'Gửi hồ sơ lên chủ tài khoản',
  },

  /**
   * Lý do xóa hồ sơ không thành công
   */
  DVCReasonDelete: {
    CompanyDirectorReject: 'Hồ sơ Thủ trưởng từ chối duyệt',
    Waiting: 'Hồ sơ đã được gửi cho KTT duyệt',
    WaitingCompanyDirector: 'Hồ sơ đã được gửi cho Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Hồ sơ đã được Thủ trưởng duyệt',
    CreatedByChiefAccountant: 'Hồ sơ của Kế toán trưởng tự tạo',
  },

  /**
   * Lý do gửi duyệt hồ sơ không thành công
   */
  DVCReasonSendApproval: {
    CompanyDirectorReject: 'Hồ sơ đã được Thủ trưởng từ chối duyệt',
    Waiting: 'Hồ sơ đã được gửi cho KTT duyệt',
    WaitingCompanyDirector: 'Hồ sơ đã được gửi cho Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Hồ sơ đã được Thủ trưởng duyệt',
    CreatedByChiefAccountant: 'Hồ sơ của Kế toán trưởng tự tạo',
  },

  /**
   * Trạng thái giao dịch (Kế toán trưởng)
   */
  DVCReasonApproval: {
    CompanyDirectorReject: 'Hồ sơ đã được Thủ trưởng từ chối duyệt',
    CompanyChiefAccountantReject: 'Hồ sơ đã được KTT từ chối duyệt',
    WaitingCompanyDirector: 'Hồ sơ đã được gửi cho Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Hồ sơ đã được Thủ trưởng đã duyệt',
  },

  /**
   * Lý do từ chối duyệt duyệt hồ sơ không thành công
   */
  DVCReasonReject: {
    CompanyDirectorReject: 'Hồ sơ được Kế toán trưởng tự lập',
    CompanyChiefAccountantReject: 'Hồ sơ đã được KTT từ chối duyệt',
    FileNotSent: 'Hồ sơ chưa gửi Thủ trưởng duyệt',
    WaitingCompanyDirector: 'Hồ sơ đã được gửi cho Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Hồ sơ đã được Thủ trưởng duyệt',
  },

  /**
   * Nội dung thanh toán
   */
  PaymentContent: {
    DescriptionDetail: 'Diễn giải chi tiết', // Diễn giải chi tiết
    DescriptionGeneral: 'Diễn giải chung', // Diễn giải chung
    BudgetItemName: 'Tên mục', // Tên mục
    BudgetSubItemName: 'Tên tiểu mục', // Tên tiểu mục
  },
  /**
   * Nội dung thanh toán
   */
  PaymentContentGroupMLNS: {
    DescriptionGeneral: 'Diễn giải chung', // Diễn giải chung
    DetailInOneLine: 'Hiển thị diễn giải chi tiết trên 1 dòng', // Diễn giải chứng từ
    BudgetItemName: 'Tên mục', // Tên mục
    BudgetSubItemName: 'Tên tiểu mục', // Tên tiểu mục
  },
  /**
   * nhóm theo:
   */
  AddGroup: {
    BudgetSubItem: 'tiểu mục',
    BudgetItem: 'mục ',
    BudgetChapter: 'chương',
    Branch: 'ngành',
    BudgetSource: 'nguồn',
  },
  /**
   * Hiển thị ở ?
   */
  AddShow: {
    top: 'Hiển thị ở trên',
    bottom: 'Hiển thị ở dưới',
  },
  /**
   * hiển thị thêm dòng theo:
   */
  ShowRow: {
    BudgetSourceGroupPropertyType: 'Tính chất nguồn',
    DescriptionVoucher: 'Diễn giải chứng từ',
  },
  /**
   * Trạng thái hóa đơn
   */
  InvoiceStatusName: {
    Replacement: 'Hóa đơn thay thế',
  },

  /**
   * Trạng thái hồ sơ KBNN
   */
  StateTreasuryStatus: {
    Waiting: 'Chờ KBNN xử lý',
    Completed: 'Đã hoàn thành giao nhận',
    Rejected: 'Từ chối',
  },
  /** *
   * Loại nghiệp vụ KB điện tử
   * nthien4 06.10.2022
   */
  DvcVoucher: {
    BUPlanWithdrawTransfer: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    BUPlanWithdrawDeposit: 'Rút dự toán tiền gửi',
    BUPlanWithdrawCash: 'Rút dự toán tiền mặt',
    CAReceiptWithdraw: 'Rút tiền mặt từ tài khoản tiền gửi',
    EMoneyTransfer: 'Chi chuyển khoản, chuyển tiền điện tử',
    PUInvoice: 'Thanh toán tạm ứng',
    PayFees: 'Nộp trả kinh phí',
    BUVoucherListRealExpense: 'Thanh toán thực chi',
    GLVoucherSummaryTable: 'Bảng tổng hợp chứng từ cùng loại',
    BUVoucherListReceipExpense: 'Bảng kê ghi thu - ghi chi',
  },

  /** *
   * Loại nghiệp vụ KB điện tử (cho kết xuất xml)
   * dtnga3 (22.11.2022)
   */
  DvcVoucherForExportXml: {
    BUPlanWithdrawTransfer: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    BUPlanWithdrawDeposit: 'Rút dự toán tiền gửi',
    BUPlanWithdrawCash: 'Rút dự toán tiền mặt',
    CAReceiptWithdraw: 'Rút tiền mặt từ tài khoản tiền gửi',
    EMoneyTransfer: 'Chi chuyển khoản, chuyển tiền điện tử',
    PUInvoice: 'Thanh toán tạm ứng',
    BUForeignPlanWithdrawTransfer: 'Rút dự toán ngoại tệ bằng chuyển khoản',
    BUForeignPlanWithdrawCash: 'Rút dự toán ngoại tệ bằng tiền mặt',
    BUInvestmentWithdrawTransfer: 'Rút vốn đầu tư bằng chuyển khoản',
    BUInvestmentWithdrawCash: 'Rút vốn đầu tư bằng tiền mặt',
    BUInvestment: 'Thanh toán vốn đầu tư',
    PayFees: 'Nộp trả kinh phí',
  },

  /**
   * Hình thức kí số
   */
  SignMethod: {
    RemoteSigning: 'Ký bằng Esign', // Ký bằng esign
    USBToken: 'Ký bằng USB token', // Ký bằng usb token
  },

  /**
   * Loại bảng tổng hợp ngày nghỉ/ làm thêm, làm đêm StatisticalTypeTable
   */
  PALayoutTemplate: {
    Luong_canBo: 'Bảng lương cán bộ',
    ChamCong_LamThemGio: 'Làm thêm, làm đêm',
    Luong_ThuNhapKhauTru: 'Bảng tổng hợp thu nhập, khấu trừ',
    TruyLinh_LuongToiThieu: 'Bảng lương truy lĩnh mức lương tối thiểu',
    Luong_BangLuong: 'Bảng lương, phụ cấp',
    Luong_LamThemGio: 'Bảng thanh toán làm đêm, làm thêm giờ',
    SalaryMS09: 'Bảng lương dành cho mẫu 09',
    Luong_TongHop: 'Trả lương',
    ChamCong_NgayNghi: 'Ngày nghỉ',
    Thue_ThangQuy: 'Bảng tính thuế theo tháng, theo quý',
    TruyLinh_LuongCanBo: 'Bảng lương truy lĩnh lương cán bộ',
    Thue_Nam: 'Bảng tính thuế cả nãm',
    Luong_BangLuong_ST: 'Bảng lương, phụ cấp (Mẫu số tiền)',
  },

  /**
   * Hình thức hóa đơn
   */
  PaymentMethod: {
    Transfer: 'Chuyển khoản', // Chuyển khoản
    CashKB: 'Tiền mặt tại kho bạc', // Tiền mặt tại kho bạc
    CaskNH: 'Tiền mặt tại ngân hàng', // Tiền mặt tại ngân hàng
  },
  DVCRole: {
    Accountant: 'Kế toán viên',
    ChiefAccountant: 'Kế toán trưởng',
    HeadOfDepartment: 'Thủ trưởng đơn vị',
  },

  /**
   * Nghị định để load hóa đơn
   */
  InvoiceType: {
    InvoiceWithCode: 'Hóa đơn có mã',
    InvoiceWithoutCode: 'Hóa đơn không mã',
  },

  /** *
   * Các báo cáo kho bạc điện tử
   * nthien4 06.10.2022
   */
  DvcReport: {
    C202a_ND11: 'C2-02a/NS',
    C202b_ND11: 'C2-02b/NS',
    C203_ND11: 'C2-03/NS',
    C205a_ND11: 'C2-05a/NS',
    C402b_ND11: 'C402_Currency_ND11',
    C402a_ND11: 'C4-02a/KB',
    C402c_ND11: 'C4-02c/KB',
    M07_ND11: 'Mẫu số 07',

    C206_ND11: 'C206NS_ND11',
    C301_ND11: 'C03_01_ND11',
    C302_ND11: 'C3_02_NS_ND11',
    PL05: '05_TT_ND99',
    MS11_ND11: 'MS11_ND11',
    M07_ND11_Portrait: 'Mẫu số 07 dọc',
  },

  /**
   * Hiển thị cột ngày, số chứng từ gốc
   * dqdat1 18.10.2022
   */
  ShowDateAndRefNo: {
    None: 'Không hiển thị',
    NoneWhenInvoice: 'Không hiển thị khi có số hóa đơn',
    DateAndRefNoOld: 'Hiển thị ngày, số chứng từ gốc',
    DateAndRefNo: 'Hiển thị ngày, số chứng từ  ',
  },
  ReportIDDVC: {
    C202a_ND11: 'C2-02a/NS',
    C202b_ND11: 'C2-02b/NS',
    C203_ND11: 'C2-03/NS',
    C205a_ND11: 'C2-05a/NS',
    C402a_ND11: 'C4-02a/KB',
    C402c_ND11: 'C4-02c/KB',
    M07_ND11: 'Mẫu số 07',
  },
  OwnerUnitGrade: {
    EstimateLevelOne: 'Đơn vị dự toán cấp 1',
    IntermediateAccountantFirst: 'Đơn vị kế toán trung gian 1',
    IntermediateAccountantSecond: 'Đơn vị kế toán trung gian 2',
  },

  /**
   * Khóa sổ kỳ kế toán
   * NXCHIEN 24.10.2022
   */
  LockVoucherGroup: {
    ref_type: 'Loại chứng từ',
    ref_date: 'Ngày chứng từ',
    posted_date: 'Ngày hạch toán',
    ref_no: 'Số chứng từ',
    type_edit: 'Hình thức xử lý',
  },

  /**
   * Trạng thái khóa sổ
   * NXCHIEN 24.10.2022
   */
  CloseBookTypeEdit: {
    Post: 'Ghi sổ',
    ChangePostedDate: 'Chuyển ngày HT',
    Remote: 'Xóa',
  },

  /**
   * Hình thức nộp
   * NHANH3 25.10.2022
   */
  PaymentType: {
    Cash: 'Tiền mặt',
    Deposit: 'Tiền gửi',
    Transfer: 'Chuyển khoản kho bạc',
  },

  /**
   * Trạng thái khóa sổ
   * NXCHIEN 24.10.2022
   */
  CloseBookTypeEdit: {
    Post: 'Ghi sổ',
    ChangePostedDate: 'Chuyển ngày HT',
    Remote: 'Xóa',
  },

  SubSystemBusiness: {
    Budget: 'Kho bạc',
    Cashonhand: 'Tiền mặt',
    Cashinbank: 'Tiền gửi',
    Inventory: 'Vật tư hàng hóa',
    Fixedasset: 'Tài sản cố định',
    Salary: 'Tiền lương',
    Sale: 'Bán hàng',
    Purchase: 'Mua hàng',
    Tax: 'Thuế',
    Generalledger: 'Sổ cái',
    Project: 'Dự án',
    Activity: 'Hoạt động sự nghiệp',
    Tool: 'Công cụ dụng cụ',
    Fund: 'Loại quỹ',
    Inventorysettlement: 'Thanh toán vật tư sử dụng tại trạm y tế',
    Topic: 'Đề tài',
    Investor: 'Chủ đầu tư',
    Task: 'Nhiệm vụ',
    Vaac: 'Đặc thù VAAC',
    Invoice: 'Hóa đơn',
    Contract: 'Hợp đồng',
  },
  ClassificationType: {
    EducationUnit: 'Đơn vị thuộc ngành Giáo dục',
    MedicalUnit: 'Đơn vị thuộc ngành Y tế',
    StateManagementUnitsAndMassOrganization: 'Đơn vị QLNN, Đảng, Đoàn thể',
    OtherUnit: 'Đơn vị Sự nghiệp khác',
  },
  BranchType: {
    Medical: 'Y tế',
    Education: 'Giáo dục',
  },

  /**
   * Kinh phí trong tham số in báo cáo
   * NVTUAN1 02.11.2022
   */
  SourceKindType: {
    TX: 'Kinh phí thường xuyên',
    KTX: 'Kinh phí không thường xuyên',
    XDCB: 'Kinh phí xây dựng cơ bản',
  },

  /**
   * Nội dung hạch toán lương
   * NNLINH 14.11.2022
   */
  PayrollExpenseType: {
    ExpenseAll: 'Hạch toán toàn bộ lương phát sinh',
    ExpenseSalary: 'Hạch toán trên số lương đã trừ các khoản bảo hiểm, kinh phí công đoàn, thuế TNCN',
    ExpenseInsurance: 'Hạch toán bảo hiểm',
    ExpenseLaborFee: 'Hạch toán kinh phí công đoàn',
    ExpenseTax: 'Hạch toán thuế TNCN',
  },
  /**
   * Kích thước trang báo cáo
   * PQDat 14.11.2022
   */
  PageSize: {
    A4: 'A4',
    A3: 'A3',
  },

  /**
   * Giá trị combobox đọc số tiền cột form tham số in chứng từ C02-HD lương
   * NHANH3 22.11.2022
   */
  ReadAmountColumn: {
    BHXHCQ: 'Trích vào CP - BHXH',
    BHYTCQ: 'Trích vào CP - BHYT',
    BHTNCQ: 'Trích vào CP - BHTN',
    KPCDCQ: 'Trích vào CP - KPCD',
    BHXH: 'Trừ vào lương - BHXH',
    BHYT: 'Trừ vào lương - BHYT',
    BHTN: 'Trừ vào lương - BHTN',
    KPCD: 'Trừ vào lương - KPCD',
    REALVALUE: 'Số thực lĩnh',
    NONE: 'Không chọn',
  },
  AdvanceFundType: {
    AdvancePaymentInvest: 'Tạm ứng vốn đầu tư',
    AdvanceInvest: 'Ứng trước vốn đầu tư',
  },
  /**
   *  Loại thanh toán
   *  ncdinh 24.11.2022
   */
  TypeOfPayment: {
    InvestmentAdvance: 'Tạm ứng vốn đầu tư',
    AdvanceInvestment: 'Ứng trước vốn đầu tư',
  },
  /**
   *  Loại thanh toán
   *  TPNAM 09.12.2022
   */
  DecreaseReasonType: {
    Liquidation: 'Thanh lý',
    Transfer: 'Điều chuyển',
    Auction: 'Bán đấu giá',
    DesignatedSale: 'Bán chỉ định',
    Transfer: 'Chuyển nhượng',
    Missing: 'Mất',
    Destroy: 'Tiêu hủy',
    AnotherForm: 'Hình thức khác',
  },
  /**
   * Tên khoản tạm thu
   *  pqkhanh 08.12.2022
   */
  TempCollection: {
    All: '<<Tất cả>>',
    Summary: '<<Tổng hợp>>',
    ExpenseCash: 'Kinh phí hoạt động bằng tiền',
    ForeignDebt: 'Viện trợ, vay nợ nước ngoài',
    TempFees: 'Tạm thu phí, lệ phí',
    AdvanceEstimate: 'Ứng trước dự toán',
    OrtherTempCollection: 'Tạm thu khác',
  },
  /* Nguồn hình thành TS cố định
   * NNKIEM 09.12.2022
   */
  SourceTypeFixedAsset: {
    StateBudget: 'Nguồn NSNN Cấp',
    ForeignDebt: 'Nguồn viện trợ, vay nợ nước ngoài',
    FeeLeave: 'Nguồn phí được khấu trừ, để lại',
    WelfareFund: 'Quỹ phúc lợi',
    CareerActivitie: 'Quỹ phát triển hoạt động sự nghiệp',
    BusinessCapital: 'Nguồn vốn kinh doanh',
    OtherSource: 'Nguồn khác',
  },
  /**
   * Kỳ tính khấu hao
   * NNKIEM 09.12.2022
   */
  DevaluationPeriod: {
    Month: 'Tháng',
    Quarter: 'Quý',
  },

  /** *
   * Các báo cáo chọn trên màn đối chiếu số dư KBĐT
   * nthien4 15.10.2022
   */
  DcsdReport: {
    N01a_SDKP_DVDT_ND112020:
      'Mẫu số 01a-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước',
    N02a_SDKP_DVDT_ND112020:
      'Mẫu số 02a-SDKP/ĐVDT: Bảng đối chiếu tình hình sử dụng kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước',
    ReportMS04: 'Mẫu số 04-SDKP/ĐVDT: Tình hình thực hiện dự toán của các nhiệm vụ được chuyển nguồn sang năm sau',
    CashInBankConfirmation:
      'Mẫu số 06-ĐCSDTK/KBNN: Bảng xác nhận số dư tài khoản tiền gửi tại KBNN (Nghị định 11/2020/NĐ-CP)',
  },
  BudgetDistributionCode: {
    Distribution1: 'Ngân sách trung ương',
    Distribution2: 'Ngân sách cấp tỉnh',
    Distribution3: 'Ngân sách cấp huyện',
    Distribution4: 'Ngân sách cấp xã',
  },
  EstimatesType: {
    Official: 'Dự toán chính thức',
    Advance: 'Dự toán ứng trước',
  },
  /**
   *  Tên khoản tạm thu
   *  pqkhanh 08.12.2022
   */
  TempCollection: {
    All: '<<Tất cả>>',
    Summary: '<<Tổng hợp>>',
    ExpenseCash: 'Kinh phí hoạt động bằng tiền',
    ForeignDebt: 'Viện trợ, vay nợ nước ngoài',
    TempFees: 'Tạm thu phí, lệ phí',
    AdvanceEstimate: 'Ứng trước dự toán',
    OrtherTempCollection: 'Tạm thu khác',
  },

  FixedAssetStatistic: {
    TT_107: 'Mẫu thông tư 107/2017/TT-BTC',
    Category_FixedAsset: 'Mẫu theo loại tài sản cố định (hiển thị riêng tài sản Đất đai)',
  },
  /**
   * Enum mục đích sử dụng S24-H: Sổ tài sản cố định
   * DDTHANG 26/12/2022
   */
  S24HUsesType: {
    Summary: 'Tổng hợp',
    All: 'Tất cả',
    Shared: 'Dùng chung',
    BusinessAndService: 'Hoạt động SXKD, dịch vụ',
    AdministrativeCareer: 'Hoạt động hành chính, sự nghiệp',
  },

  S24HQuantity: {
    ShowQuantity: 'Hiển thị số lượng trên Sổ',
    HideQuantity: 'Không hiển thị số lượng trên Sổ',
  },

  /**
   * loại tờ khai giá trị gia tăng
   * tvhien 03.01.2023
   */
  CircularVATType: {
    VATFirst: 'Tờ khai lần đầu',
    VATAdditional: 'Tờ khai bổ sung',
  },

  /**
   * Thông tư áp dụng cho phân hệ thuế - tờ khai giá trị gia tăng
   * tvhien 03.01.2023
   */
  ApplicableCircular: {
    TT80: 'TT 80/2021/TT-BTC',
  },
  /**
   * Danh mục ngành nghề
   * tvhien 05/01/2023
   */
  Occupation: {
    ActivityManufact: 'Hoạt động sản xuất kinh doanh thông thường',
    ActivityLottery: 'Hoạt động xổ số kiến thiết, xổ số điện toán',
    ActivityProbe: 'Hoạt động thăm dò khai thác dầu khí',
    InvestmentProject: 'Dự án đầu tư cơ sở hạ tầng, nhà để chuyển nhượng khác địa bàn tỉnh nơi đóng trụ sở chính',
    FactoryElectrict: 'Nhà máy sản xuất điện khác địa bàn tỉnh nơi đóng trụ sở chính',
  },

  // Enum các loại phụ lục tờ khai thuế
  VatAppendixType: {
    TaSaleListIn: 'Bảng kê hóa đơn, chứng từ hàng hóa, dịch vụ mua vào', // Bảng kê hàng hóa mua vào
    TaSaleListOut: 'Bảng kê hóa đơn, chứng từ hàng hóa, dịch vụ bán ra', // Bảng kê hàng hóa bán ra
    TaPL01KHBS: 'Tờ khai bổ sung', // Phụ lục tờ khai bổ sung
    TaPL011KHBS: 'Bản giải trình khai bổ sung', // Phụ lục giải trình khai bổ sung
    Ta432022QH15: 'Giảm thuế giá trị gia tăng theo Nghị quyết 43/2022/QH15', // Phụ lục theo Nghị quyết 43/2022/QH15
  },

  /**
   * Loại chứng từ dùng cho tiện ích Sắp cếp lại số CT
   * dtnga3 (06.01.2023)
   */
  SortRefTypeGroup: {
    BUPlan: 'Nhận dự toán',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    BUPlanWithdraw: 'Rút dự toán',
    BUTransfer: 'Chuyển khoản kho bạc',
    CAReceipt: 'Phiếu thu',
    CAPayment: 'Phiếu chi',
    BADeposit: 'Thu tiền gửi',
    BAWithDraw: 'Chi tiền gửi',
    BATransfer: 'Tiền đang chuyển',
    INInward: 'Nhập kho',
    INOutward: 'Xuất kho',
    INTransfer: 'Chuyển kho',
    INAdjustment: 'Điều chỉnh tồn kho',
    SUIncrement: 'Ghi tăng công cụ dụng cụ',
    SUDecrement: 'Ghi giảm công cụ dụng cụ',
    SUTransfer: 'Điều chuyển công cụ dụng cụ',
    FAIncrement: 'Ghi tăng tài sản cố định',
    FADecrement: 'Ghi giảm tài sản cố định',
    FAAdjustment: 'Đánh giá lại tài sản cố định',
    FATransfer: 'Điều chuyển phòng/ban',
    PUInvoice: 'Hóa đơn mua hàng, tài sản',
    SAInvoice: 'Hóa đơn bán hàng',
    GLGeneralVoucher: 'Chứng từ nghiệp vụ khác',
    BUVoucherList: 'Bảng kê chứng từ thanh toán',
    BUPlanCancel: 'Hủy dự toán',
    BUExpenseWithdrawAdjustment: 'Điều chỉnh kinh phí',
    BABankTransfer: 'Chuyển tiền nội bộ',
    SAReturn: 'Hàng bán trả lại',
    GLProvisionalTaxInComeEnterprise: 'Tạm tính thuế thu nhập doanh nghiệp',
    GLFinalTaxInComeEnterprise: 'Quyết toán thuế thu nhập doanh nghiệp',
  },
  /**
   * Map table với module dùng cho invalid cache
   * TVDAT 15/02/2023
   */
  TableMapModule: {
    di_account: 'account',
    di_account_transfer: 'accountTransfer',
    sys_ref_type: 'defaultAccount',
    di_account_parallel_rule: 'accountParallelRule',
    di_account_parallel_rule_detail: 'accountParallelRule',
    di_auto_business: 'autoBusiness',
    di_budget_chapter: 'budgetChapter',
    di_budget_kind_item: 'budgetKindItem',
    di_budget_item: 'budgetItem',
    di_budget_source: 'budgetSource',
    di_budget_source_property: 'budgetSourceProperty',
    di_project: 'project',
    di_budget_provide: 'budgetProvide',
    di_fund: 'fund',
    di_currency: 'currency',
    di_bank_info_category: 'bankInfoCategory',
    di_bank_info: 'bankInfo',
    di_accounting_object_category: 'accountingObjectCategory',
    di_accounting_object_employee: 'accountingObject',
    di_accounting_object_customerVendor: 'customerVendor',
    di_fixed_asset: 'fixedAssetCache',
    di_fixed_asset_category: 'fixedAssetCategory',
    di_department: 'department',
    di_employee_type: 'employeeType',
    di_payroll_item: 'payrollItem',
    di_salary_scale: 'salaryScale',
    inventory_item: 'inventoryItem',
    di_inventory_category: 'inventoryCategory',
    di_stock: 'stock',
    di_purchase_purpose: 'purchasePurpose',
    di_invoice_form_number: 'invoiceFormNumber',
    di_voucher_type: 'voucherType',
    di_budget_fees: 'budgetFees',
    di_task: 'task',
    di_topic: 'topic',
    di_activity: 'activity',
    di_fund_structure: 'fundStructure',
    di_statistic: 'statistic',
    di_budget_group_item: 'budgetGroupItem',
    di_contract: 'contract',
    di_inventory_item: 'inventoryItem',
    di_tool_inventory_category: 'toolType',
    di_auto_business_detail: 'autoBusiness',
    di_auto_business_detail_parallel: 'autoBusiness',
  },

  /**
   * Loại dự toán
   * bvbao 22.03.2023
   */
  BudgetPlanType: {
    All: 'Tất cả',
    BeginNMLNS: 'Dự toán thu đầu năm theo MLNS',
    AdditionalMLNS: 'Dự toán thu bổ sung theo MLNS',
    ReadjustMLNS: 'Điều chỉnh dự toán thu theo MLNS',
    BeginNDKT: 'Dự toán thu đầu năm theo NDKT',
    AdditionalNDKT: 'Dự toán thu bổ sung theo NDKT',
    ReadjustNDKT: 'Điều chỉnh dự toán thu theo NDKT',
  },
  IsReadjust: {
    Readjust: 'Áp dụng cho chứng từ trong thời gian chỉnh lý',
    NotReadjust: 'Áp dụng cho chứng từ không phải chỉnh lý',
  },
  /**
   * Loại thuế thu nhập
   */
  IncomeTax: {
    Regular: 'Thường xuyên',
    NoneRegular: 'Không thường xuyên',
  },
  /**
   * Đối chiếu nguồn
   */
  MappingSourceQLTS: {
    BudgetSourceOnQLTS: 'Nguồn kinh phí đang quản lý trên MISA QLTS',
    BudgetSourceOnBamboo: 'Nguồn kinh phí trên MISA Bamboo',
  },
  /**
   * Trạng thái ghi sổ
   */
  StatusWriteLedger: {
    Writed: 'Ghi sổ',
    NotWrited: 'Chưa ghi sổ',
  },
  /**
   * Nhật ký truy cập
   */
  Action: {
    Insert: 'Thêm',
    Update: 'Sửa',
    Delete: 'Xóa',
  },

  /**
   * Quyền sau cần thì bổ sung thêm sau
   */
  Permission: {
    Add: 'Thêm',
    Edit: 'Sửa',
    Delete: 'Xóa',
    BackupData: 'Sao lưu dữ liệu',
    RestoreData: 'Phục hồi dữ liệu',
    CreateData: 'Thêm mới dữ liệu',
    CreateDataPrevYear: 'Thêm mới từ dữ liệu năm trước',
    DeleteData: 'Xóa dữ liệu',
    Posted: 'Ghi sổ',
    UnPost: 'Bỏ ghi sổ',
    RenameData: 'Đổi tên dữ liệu',
    RestoreVoucher: 'Phục hồi',
    RebuildData: 'Bảo trì',
    ConvertBudgetKindItem: 'Chuyển loại khoản',
    ConvertAccount: 'Chuyển tài khoản hạch toán',
    ConvertBudgetSource: 'Chuyển nguồn kinh phí',
    ImportDic: 'Nhập từ Excel',
    SettingRole: 'Vai trò và quyền hạn',
    // Các giá trị cần thêm
    Attach: 'Đính kèm',
    DeleteFileAttach: 'Xóa tệp đính kèm',
    SendFileChiefAcc: 'Gửi hồ sơ lên kế toán trưởng',
    ChiefAccAccept: 'Kế toán trưởng ký duyệt',
    ChiefAccReject: 'Kế toán trưởng từ chối',
    ConfirmUser: 'Xác nhận người dùng',
    ImportOverWrite: 'Nhập khẩu ghi đè',
    ImportUpdate: 'Nhập khẩu cập nhật',
    CloseBook: 'Khóa sổ',
    UpdateDbOption: 'Cập nhật dboption',
    HideShowColumn: 'Ẩn hiện cột',
    SettingReport: 'Thiết lập BC tài chính',
    PayAdvancePayment: 'Thanh toán bảng kê',
    RecordReceiptExpense: 'Ghi thu - ghi chi',
    CancelReceiptExpense: 'Hủy',
    RecordReceiptNSNN: 'Ghi thu vào NSNN',
    CancelReceiptNSNN: 'Hủy',
    CopyData: 'Sao chép dữ liệu',
  },

  /* Trạng thái sao lưu dữ liệu
   * ndhieu3 24.04.2023
   */
  BackupDataStatus: {
    BackingUp: 'Đang sao lưu',
    BackupSuccessful: 'Sao lưu thành công',
    BackupFailed: 'Sao lưu thất bại',
    OverdueRecovery: 'Quá hạn phục hồi',
    WaitingRestore: 'Đang phục hồi',
  },
  /**
   * Enum Trạng thái database
   * ndhieu3 19.06.2023
   */
  StatusDatabase: {
    // Đang làm việc
    Working: 1,
    // Dữ liệu lỗi
    DataError: 2,
    // Không làm việc
    NotWorking: 3,
  },

  /**
   * Enum trạng thái busy của database
   */
  BusyDatabaseType: {
    // None
    None: '',

    // Sao lưu
    Backuping: 'Sao lưu',

    // Phục hồi
    Restoring: 'Phục hồi',

    // Bảo trì
    Maintaning: 'Bảo trì',
  },

  /**
   * Action của lịch sử quản lý dữ liệu
   * ndhieu3 25.04.2023
   */
  BackupAction: {
    Recovery: 'Phục hồi dữ liệu',
    BackUp: 'Sao lưu dữ liệu',
  },

  /**
   * Loại thu
   */
  ReceiptType: {
    Money: 'Tiền',
    Artifact: 'Hiện vật',
    WorkDay: 'Ngày công',
  },

  /**
   * @description Kết quả thực hiện
   * @author nvthinh 24.05.2023
   */
  DeleteResult: {
    Success: 'Thành công',
    NotSuccess: 'Không thành công',
  },

  /**
   * @description Kết quả thực hiện
   */
  PostResult: {
    Success: 'Thành công',
    NotSuccess: 'Không thành công',
  },

  /**
   * Enum trạng thái tài sản
   */
  LastState: {
    InUsed: 'Đã mua chưa dùng',
    Disposed: 'Đã thanh lý, nhượng bán',
    InUsedDepreciation: 'Đang dùng và tính HM',
    NotDepreciation: 'Ngừng tính HM',
  },

  /**
   * Enum loại tái sản điều chuyển
   */
  FATransfer: {
    All: 'Tất cả',
    NotTransfer: 'Không phải Tài sản điều chuyển',
    IsTransfer: 'Tài sản điều chuyển',
  },

  /**
   * Danh sách các năm
   * VDDONG 27/04/2023
   */
  ListYear: {
    Y2020: '2020',
    Y2021: '2021',
    Y2022: '2022',
    Y2023: '2023',
    Y2024: '2024',
  },
  SortRefNoResultStatus: {
    Success: 'Thành công',
    Fail: 'Thất bại',
  },
  /**
   * Tên dự toán
   * NVTUYEN 25.05.2023
   */
  BuPlanExpense: {
    BuPlanExpenseBudget: 'Dự toán chi đầu năm theo MLNS',
    BuPlanExpenseBudgetAdd: 'Dự toán chi bổ sung theo MLNS',
    BuPlanExpenseBudgetSupplement: 'Dự toán chi điều chỉnh theo MLNS',
    BuPlanExpenseActivity343: 'Dự toán chi đầu năm theo NDKT (Mẫu TT 343/2016/TT-BTC)',
    BuPlanExpenseActivityAdd343: 'Dự toán chi bổ sung theo NDKT (Mẫu TT 343/2016/TT-BTC)',
    BuPlanExpenseActivitySupplement343: 'Dự toán chi điều chỉnh theo NDKT (Mẫu TT 343/2016/TT-BTC)',
    BuPlanExpenseActivity344: 'Dự toán chi đầu năm theo NDKT (Mẫu TT 344/2016/TT-BTC)',
    BuPlanExpenseActivityAdd344: 'Dự toán chi bổ sung theo NDKT (Mẫu TT 344/2016/TT-BTC)',
    BuPlanExpenseActivitySupplement344: 'Dự toán chi điều chỉnh theo NDKT (Mẫu TT 344/2016/TT-BTC)',
    BuPlanExpenseActivityVt: 'Dự toán chi đầu năm theo NDKT (Vũ Thư)',
    BuPlanExpenseActivityAddVt: 'Dự toán chi bổ sung theo NDKT (Vũ Thư)',
    BuPlanExpenseActivitySupplementVt: 'Dự toán chi điều chỉnh theo NDKT (Vũ Thư)',
    BuPlanExpenseActivity342: 'Dự toán chi đầu năm theo NDKT (Mẫu TT 342/2016/TT-BTC)',
    BuPlanExpenseActivityAdd342: 'Dự toán chi bổ sung theo NDKT (Mẫu TT 342/2016/TT-BTC)',
    BuPlanExpenseActivitySupplement342: 'Dự toán chi điều chỉnh theo NDKT (Mẫu TT 342/2016/TT-BTC)',
  },

  /**
   * Enum các loại dự toán chi
   * bvbao 05.06.2023
   */
  BuPlanExpenseType: {
    BuPlanExpenseBudget: 'Dự toán chi đầu năm theo MLNS',
    BuPlanExpenseBudgetAdd: 'Dự toán chi bổ sung theo MLNS',
    BuPlanExpenseBudgetSupplement: 'Điều chỉnh dự toán chi theo MLNS',
    BuPlanExpenseActivity: 'Dự toán chi đầu năm theo NDKT',
    BuPlanExpenseActivitySupplement: 'Dự toán chi bổ sung theo NDKT',
    BuPlanExpenseActivityAdjust: 'Điều chỉnh dự toán chi theo NDKT',
  },

  /**
   * Enum các Tên dự toán thu
   * bvbao 05.06.2023
   */
  BuPlanReceipt: {
    BuPlanReceiptBudget: 'Dự toán thu đầu năm theo MLNS',
    BuPlanReceiptBudgetAdd: 'Dự toán thu bổ sung theo MLNS',
    BuPlanReceiptBudgetSupplement: 'Dự toán thu điều chỉnh theo MLNS',
    BuPlanReceiptActivity343: 'Dự toán thu đầu năm theo NDKT (Mẫu TT 343/2016/TT-BTC)',
    BuPlanReceiptActivityAdd343: 'Dự toán thu bổ sung theo NDKT (Mẫu TT 343/2016/TT-BTC)',
    BuPlanReceiptActivitySupplement343: 'Dự toán thu điều chỉnh theo NDKT (Mẫu TT 343/2016/TT-BTC)',
    BuPlanReceiptActivity344: 'Dự toán thu đầu năm theo NDKT (Mẫu TT 344/2016/TT-BTC)',
    BuPlanReceiptActivityAdd344: 'Dự toán thu bổ sung theo NDKT (Mẫu TT 344/2016/TT-BTC)',
    BuPlanReceiptActivitySupplement344: 'Dự toán thu điều chỉnh theo NDKT (Mẫu TT 344/2016/TT-BTC)',
    BuPlanReceiptActivity342: 'Dự toán thu đầu năm theo NDKT (Mẫu TT 342/2016/TT-BTC)',
    BuPlanReceiptActivityAdd342: 'Dự toán thu bổ sung theo NDKT (Mẫu TT 342/2016/TT-BTC)',
    BuPlanReceiptActivitySupplement342: 'Dự toán thu điều chỉnh theo NDKT (Mẫu TT 342/2016/TT-BTC)',
  },

  /**
   * Enum các loại dự toán thu
   * bvbao 05.06.2023
   */
  BuPlanReceiptType: {
    BuPlanReceiptBudget: 'Dự toán thu đầu năm theo MLNS',
    BuPlanReceiptBudgetAdd: 'Dự toán thu bổ sung theo MLNS',
    BuPlanReceiptBudgetSupplement: 'Điều chỉnh dự toán thu theo MLNS',
    BuPlanReceiptActivity: 'Dự toán thu đầu năm theo NDKT',
    BuPlanReceiptActivitySupplement: 'Dự toán thu bổ sung theo NDKT',
    BuPlanReceiptActivityAdjust: 'Điều chỉnh dự toán thu theo NDKT',
  },

  /**
   * Enum trạng thái
   * Dùng trong bộ lọc
   * VDDONG 23/05/2023
   */
  ActiveFilter: {
    Active: 'Theo dõi',
    Inactive: 'Ngừng theo dõi',
  },

  /**
   * Enum trạng thái tài sản cố định
   * ndquang1 30/06/2023
   */
  StatusFixedAsset: {
    NotChoose: 'Không chọn',
    BoughtNotUsed: 'Đã mua nhưng chưa dùng (Chưa tính hao mòn)',
    Using: 'Đang dùng và tính hao mòn',
    StopDepreciation: 'Ngưng tính hao mòn',
    Saled: 'Đã thanh lý, nhượng bán',
  },

  ColumnsGroupType: {
    Order: 'Hóa đơn',
    Increment: 'Chứng từ',
    Position: 'Chức danh',
    Department: 'Phòng ban',
    SalaryGrade: 'Lương nghạch bậc',
  },
  SortType: {
    NoSort: 'Không sắp xếp',
    SmallToLarge: 'Từ nhỏ đến lớn',
    LargeToSmall: 'Từ lớn đến nhỏ',
  },
  NumberedType: {
    NoNumbered: 'Không đánh số thứ tự',
    ToEnd: 'Từ một đến hết',
    RepeatGroup: 'Lặp lại trên từng nhóm',
    Serial: 'Nối tiếp',
  },
  ContentType: {
    Code: 'Mã',
    Name: 'Tên',
    Multi: 'Cộng <>',
    Plus: 'Cộng',
    Empty: 'Để trống',
    Custom: 'Tùy biến hiển thị',
  },
  DisplayType: {
    MNLSName: '<Loại MNLS: ><Tên MLNS>',
    MNLSCode: '<Loại MNLS: ><Mã MLNS>',
    MLNS: '<Mã MLNS>',
    Hide: 'Không hiển thị',
  },

  // Tổng hợp dự toán
  PlanSummary: {
    ReceiptBudget: 'Tổng hợp dự toán thu theo MLNS',
    ReceiptActivity342: 'Tổng hợp dự toán thu theo NDKT(Mẫu TT 342/2016/TT-BTC)',
    ReceiptActivity343: 'Tổng hợp dự toán thu theo NDKT(Mẫu TT 343/2016/TT-BTC)',
    ReceiptActivity344: 'Tổng hợp dự toán thu theo NDKT(Mẫu TT 344/2016/TT-BTC)',
    PaymentBudget: 'Tổng hợp dự toán chi theo MLNS',
    PaymentActivity342: 'Tổng hợp dự toán chi theo NDKT(Mẫu TT 342/2016/TT-BTC)',
    PaymentActivity343: 'Tổng hợp dự toán chi theo NDKT(Mẫu TT 343/2016/TT-BTC)',
    PaymentActivity344: 'Tổng hợp dự toán chi theo NDKT(Mẫu TT 344/2016/TT-BTC)',
  },

  // Tổng hợp dự toán đặc thù Vũ Thư
  PlanSummaryVuThu: {
    ReceiptBudget: 'Tổng hợp dự toán thu theo MLNS',
    ReceiptActivity342: 'Tổng hợp dự toán thu theo NDKT(Mẫu TT 342/2016/TT-BTC)',
    ReceiptActivity343: 'Tổng hợp dự toán thu theo NDKT(Mẫu TT 343/2016/TT-BTC)',
    ReceiptActivity344: 'Tổng hợp dự toán thu theo NDKT(Mẫu TT 344/2016/TT-BTC)',
    PaymentBudget: 'Tổng hợp dự toán chi theo MLNS',
    PaymentActivity342: 'Tổng hợp dự toán chi theo NDKT(Mẫu TT 342/2016/TT-BTC)',
    PaymentActivity343: 'Tổng hợp dự toán chi theo NDKT(Mẫu TT 343/2016/TT-BTC)',
    PaymentActivity344: 'Tổng hợp dự toán chi theo NDKT(Mẫu TT 344/2016/TT-BTC)',
    PaymentActivityVuThu: 'Tổng hợp dự toán chi theo NDKT(Vũ Thư)',
  },

  PlanSummaryType: {
    ReceiptBudget: 'Dự toán thu theo MLNS',
    ReceiptActivity: 'Dự toán thu theo NDKT',
    PaymentBudget: 'Dự toán chi theo MLNS',
    PaymentActivity: 'Dự toán chi theo NDKT',
  },
  StatusVoucher: {
    IsPayment: 'Đã thanh toán',
    IsNotPayment: 'Chưa thanh toán',
    ReceiptIsPayment: 'Đã ghi thu, ghi chi',
    ReceiptIsNotPayment: 'Chưa ghi thu, ghi chi',
  },
  StatusVoucherAdvanceNSNN: {
    ReceiptIsNotPayment: 'Chưa ghi thu vào NSNN',
    ReceiptIsPayment: 'Đã ghi thu vào NSNN',
  },
  CheckMultiGrid: {
    All: 'Tất cả',
    Choosed: 'Chọn',
    NotChoose: 'Không chọn',
  },

  RefTypeSuVoucherSameType: {
    CAReceipt: 'Phiếu thu',

    CAPayment: 'Phiếu chi',

    BADeposit: 'Nộp tiền kho bạc',

    BUTreasuryWithdrawal: 'Rút tiền kho bạc',

    BAInternalTransfer: 'Chuyển tiền nội bộ',

    BAWithDraw: 'Chi tiền gửi',

    BUTransfer: 'Chuyển khoản kho bạc',

    BUTransferDeposit: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',

    InInventory: 'Nhập kho',

    INOutward: 'Phiếu xuất kho',

    InventoryTransfer: 'Chuyển kho',

    FixedAssetIncrement: 'Ghi tăng TSCĐ',

    FixedAssetDecrement: 'Ghi giảm TSCĐ',

    FixedAssetAdjustment: 'Điều chỉnh TSCĐ',

    FixedAssetDepreciation: 'Hao mòn TSCĐ',

    ToolIncrement: 'Ghi tăng CCDC',

    ToolDecrement: 'Ghi giảm CCDC',

    ToolTransfer: 'Điều chuyển CCDC',

    SUGeneralVoucher: 'Chứng từ nghiệp vụ khác',

    SUAccountTransfer: 'Phiếu kết chuyển tài khoản',

    BUReceiveBudgetPlan: 'Nhận dự toán đầu năm',

    BUReceiveBudgetPlanSupplement: 'Nhận dự toán bổ sung',

    BUPlanAdjustment: 'Điều chỉnh dự toán',

    BUPlanCancel: 'Hủy dự toán',
    GlPayrollExpense: 'Hạch toán chi phí lương, BH, KPCĐ',
  },
  RefTypeSearch: {
    CAReceipt: 'Phiếu thu',
    CAPayment: 'Phiếu chi',
    BADeposit: 'Nộp tiền kho bạc',
    BUTreasuryWithdrawal: 'Rút tiền kho bạc',
    BAInternalTransfer: 'Chuyển tiền nội bộ',
    BAWithDraw: 'Chi tiền gửi',
    BUTransfer: 'Chuyển khoản kho bạc',
    BUTransferDeposit: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
    INInward: 'Nhập khác',
    INOutward: 'Phiếu xuất kho',
    InventoryInwardCash: 'Nhập mua bằng tiền mặt',
    InventoryInwardDeposit: 'Nhập mua bằng tiền gửi',
    InventoryTransfer: 'Chuyển kho',
    FixedAssetIncrement: 'Ghi tăng TSCĐ',
    FixedAssetDecrement: 'Ghi giảm TSCĐ',
    FixedAssetAdjustment: 'Điều chỉnh TSCĐ',
    FixedAssetDepreciation: 'Hao mòn TSCĐ',
    ToolIncrement: 'Ghi tăng CCDC',
    ToolDecrement: 'Ghi giảm CCDC',
    ToolTransfer: 'Điều chuyển CCDC',
    SUGeneralVoucher: 'Chứng từ nghiệp vụ khác',
    SUAccountTransfer: 'Phiếu kết chuyển tài khoản',
    ParallelVoucher: 'Chứng từ ghi đồng thời',
    TranferReceiptClear: 'Kết chuyển chênh lệch thu, chi ngân sách xã',
    TranferClosing: 'Kết chuyển cuối năm',
    TransferBudgetBalance: 'Kết chuyển kết dư sang thu ngân sách xã',
    TransferActivity: 'Kết chuyển hoạt động sự nghiệp',
    TransferBegining: 'Quyết toán dự toán chi ngân sách cuối năm',
    TranferReceiptClearInMonth13: 'Kết chuyển chênh lệch thu, chi ngân sách trong thời gian chỉnh lý',
    BUReceiveBudgetPlan: 'Nhận dự toán đầu năm',
    BUReceiveBudgetPlanSupplement: 'Nhận dự toán bổ sung',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    BUPlanCancel: 'Hủy dự toán',
    BUExpenseWithdrawAdjustment: 'Điều chỉnh kinh phí',
    GlPayrollExpense: 'Hạch toán chi phí lương, BH, KPCĐ',
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ QLTS.VN', //Ghi tăng TSCĐ từ QLTS.VN
    FAVoucherAdjustment: 'Điều chỉnh TSCĐ từ QLTS.VN', //Điều chỉnh TSCĐ từ QLTS.VN
    FAVoucherDepreciate: 'Lấy khấu hao TSCĐ từ QLTS.VN',
    FAVoucherDepreciation: 'Hao mòn TSCĐ từ QLTS.VN', //Hao mòn TSCĐ từ QLTS.VN
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ QLTS.VN', //Ghi giảm TSCĐ từ QLTS.VN
  },
  CashWithDrawReportType: {
    Spend: 'Thực chi',
    Advance: 'Tạm ứng',
    AdvanceQualified: 'Ứng trước đủ đk thanh toán',
    AdvanceNotQualified: 'Ứng trước chưa đủ đk thanh toán',
    None: 'Không chọn',
  },
  ReportTypeS02aX: {
    cashBook: 'S02a-X: Sổ quỹ tiền mặt',
    cashBookObject: 'S02a-X: Sổ quỹ tiền mặt (Có đối tượng)',
  },

  ReportTypeS22X: {
    S22X_P1: 'Mẫu S22-X-Phần I',
    S22X_P2: 'Mẫu S22-X-Phần II',
  },

  ReportTypeS08X: {
    cashBook: 'S08-X: Sổ phải thu',
    cashBookObject: 'S08-X: Sổ phải thu (Có đối tượng)',
  },

  ReportTypeS09X: {
    cashBook: 'S09-X: Sổ phải trả',
    cashBookObject: 'S08-X: Sổ phải trả (Có đối tượng)',
  },

  ReportTypeS02bX: {
    s02bX: 'S02b-X: Sổ nhật ký thu, chi quỹ tiền mặt',
    cashBook: 'Sổ nhật ký thu, chi quỹ tiền mặt (mẫu ngang)',
    cashBookObject: 'Sổ nhật ký thu, chi quỹ tiền mặt (Có đối tượng)',
  },
  ReportTemplate: {
    C202a: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C202b: 'C2-02b/NS: Giấy rút dự toán ngân sách (Nghị định 11/2020/NĐ-CP)',
    Ms07: 'Mẫu số 07: Bảng kê nội dung thanh toán tạm ứng',
    C402a: 'C4-02a/NS: Ủy nhiệm chi chuyển khoản, chuyển tiền điện tử',
    C402c: 'C4-02c/NS: Ủy nhiệm chi chuyển khoản, chuyển tiền điện tử ',
    M05tt: 'Mẫu 05/TT: Giấy rút vốn đầu tư (Nghị định 99/2021/NĐ-CP)',
    C203: 'C2-03/NS: Giấy đề nghị thanh toán tạm ứng/ứng trước (Nghị định 11/2020/NĐ-CP)',
    C205a: 'C2-05a/NS: Giấy nộp trả kinh phí (Nghị định 11/2020/NĐ-CP)',
    M04att: 'Mẫu 04.a/TT: Giấy đề nghị thanh toán vốn (Nghị định 99/2021/NĐ-CP)',
    M04btt: 'Mẫu 04.b/TT: Giấy đề nghị thu hồi vốn (Nghị định 99/2021/NĐ-CP)',
    Ms09: 'Mẫu số 09: Bảng thanh toán cho đối tượng thụ hưởng',
  },
  CashWithDrawDVC: {
    TreasuryCash: 'Rút dự toán tiền mặt',
    TreasuryTransfer: 'Rút dự toán chuyển khoản',
    TreasuryToAccountCash: 'Rút dự toán về tài khoản tiền gửi',
    TreasuryDepositsToCash: 'Rút tiền gửi Kho bạc về tiền mặt',
    SpendTransfer: 'Chi tiền gửi tại Kho bạc',
    AdvancePayment: 'Thanh toán tạm ứng',
    InvestmentWithTransfer: 'Rút vốn đầu tư bằng chuyển khoản',
    InvestmentWithCash: 'Rút vốn đầu tư bằng tiền mặt',
    InvestmentAdvance: 'Thanh toán tạm ứng vốn đầu tư',
    Adjustment: 'Nộp trả kinh phí',
  },
  PaymentMethodDVC: {
    Transfer: 'Chuyển khoản', // Chuyển khoản
    CashKB: 'Tiền mặt tại kho bạc', // Tiền mặt tại kho bạc
    CaskNH: 'Tiền mặt tại ngân hàng', // Tiền mặt tại ngân hàng
  },
  ProficientDVC: {
    Dicrect: 'Thanh toán trực tiếp',
    Advance: 'Tạm ứng',
  },
  UserType: {
    Accountant: 'Kế toán viên',
    ChiefAccountant: 'Kế toán trưởng',
    DelegateChiefAccountant: 'Uỷ quyền kế toán trưởng',
    HeadOfDepartment: 'Thủ trưởng đơn vị',
    DelegateHeadOfDepartment: 'Uỷ quyền chủ tài khoản',
    OtherAccountant: 'Khác',
    KBNN: 'Kho bạc nhà nước',
  },
  DvcOpenAt: {
    Treasury: 'Kho bạc',
    Bank: 'Ngân hàng',
  },
  DetailForBasicConstructor: {
    Protect: 'Dự án',
    Construction: 'Công trình',
    ConstructionWorkItems: 'Hạng mục công trình',
  },

  StateActivityCompared: {
    NoAction: '',
    AddActivity: 'Thêm chỉ tiêu',
    RemoveActivity: 'Bỏ chọn chỉ tiêu',
    ReselectActivity: 'Chọn lại chỉ tiêu',
  },

  UpDownEnum: {
    Asc: 'Tăng dần',
    Desc: 'Giảm dần',
  },

  Action: {
    Insert: 'insert',
    Update: 'update',
  },
  InbotInvoiceStatus: {
    // Chờ kiểm tra: Nếu Tình trạng hóa đơn trên Inbot là Đang kiểm tra
    Waiting: 'Chờ kiểm tra',
    // Cảnh báo: Nếu Tình trạng hóa đơn trên Inbot là Không hợp lệ, Không có bản thể hiển, Bản nháp, Không có XML
    Invalid: 'Cảnh báo',
    // Hợp lệ:  Nếu Tình trạng hóa đơn trên Inbot là Hợp lệ
    Valid: 'Hợp lệ',
  },
  // Trạng thái hoá đơn
  StatusInvoice: {
    Goc: 'HĐ mới', // Hóa đơn gốc
    ThayThe: 'HĐ thay thế', // Hóa đơn thay thế
    DieuChinh: 'HĐ điều chỉnh', // Hóa đơn điều chỉnh
    DaThayThe: 'HĐ đã bị thay thế', // Hóa đơn đã bị thay thế
    DaDieuChinh: 'HĐ đã bị điều chỉnh', // Hóa đơn đã bị điều chỉnh
    Xoa: 'HĐ đã bị huỷ', // Hóa đơn đã bị xóa bỏ/hủy bỏ
    Unknown: 'HĐ chưa xác định', // Hóa đơn chưa xác định
  },

  InbotVoucherAccountingType: {
    // Chưa hạnh toán
    NotAccounted: 'Chưa hạch toán',
    //Không hạch toán
    NoAccounted: 'Không hạch toán',
    //Đã hạch toán
    Accounted: 'Đã hạch toán',
  },

  InbotVoucherCreatedStatus: {
    // Đã lập
    Created: 'Đã lập',
    // Chưa lập
    NotCreated: 'Chưa lập',
  },

  MethodPaymentInvoice: {
    BuTranfer: 'Chuyển khoản kho bạc',
    Bawithdraw: 'Chi tiền gửi',
    CashPayment: 'Chi tiền mặt',
    BUTreasuryWithdrawal: 'Phiếu rút tiền kho bạc',
    Butransferdeposit: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
  },
  ReportCaReceiptType: {
    CaReceipt: 'Phiếu thu',
    CaReceiptTwo: 'Phiếu thu (2 liên)',
    CaReceiptMLNS: 'Phiếu thu MLNS',
    CaReceiptA5: 'Phiếu thu giấy cuộn A5',
    CaReceiptA5A4: 'Phiếu thu A5 in trên khổ A4',
  },

  ReportCaPaymentType: {
    CaPayment: 'Phiếu chi',
    CaPaymentTwo: 'Phiếu chi (2 liên)',
    CaPaymentMLNS: 'Phiếu chi MLNS',
    CaPaymentA5: 'Phiếu chi giấy cuộn A5',
    CaPaymentA5A4: 'Phiếu chi A5 in trên khổ A4',
  },

  LekimaStatus: {
    Sent: 'Đã nộp',
    Submitted: 'Đã đồng ý',
    NeedAdjust: 'Cần sửa lại',
    Resent: 'Đã nộp lại',
    NoSent: 'Chưa nộp', // TODO:
  },

  LekimaReportPeriod: {
    Year: 'Cả năm',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: 'Sáu tháng đầu năm',
    SecondHalfYear: 'Sáu tháng cuối năm',
  },
  DcsdReport: {
    MS01a:
      'Biểu số 01a-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách bằng hình thức rút dự toán tại kho bạc nhà nước lên KBNN',
    MS02a:
      'Biểu số 02a-SDKP/ĐVDT: Bảng đối chiếu tình hình sử dụng kinh phí ngân sách bằng hình thức rút dự toán tại KBNN',
    MS04: 'Biểu số 04-SDKP/ĐVDT: Tình hình thực hiện dự toán của các nhiệm vụ được chuyển nguồn sang năm sau',
    MS06: 'Biểu số 06-ĐCSDTK/KBNN: Bảng xác nhận số dư tài khoản tiền gửi tại KBNN',
  },

  RefTypeFilterVoucherNotGenParallel: {
    All: 'Tất cả',
    CaReceipt: 'Phiếu rút tiền kho bạc', //31
    BuTransfer: 'Chuyển khoản kho bạc', //34, 165
  },

  FundInventoryStatus: {
    Normal: '',
    Saved: 'Chưa xử lý chênh lệch',
    HandledDiff: 'Đã xử lý chênh lệch',
  },

  RefTypeHandleDiffAmount: {
    All: 'Tất cả',
    CAReceipt: 'Phiếu thu', // 20
    CAPayment: 'Phiếu chi', // 21
  },

  ExaminationStatus: {
    Inappropriate: 'Chưa phù hợp',
    Appropriate: 'Phù hợp',
    Undefined: 'Không đủ căn cứ',
  },

  CopyDataMappingStatus: {
    Incomplete: '',
    Complete: 'Hoàn tất ghép dữ liệu',
  },
  /**
   * Enum hành động quản lý dữ liệu
   */
  DatabaseAction: {
    CreateNew: 'Thêm mới từ đầu',
    CreateFromPrevYear: 'Thêm mới từ năm trước',
    Rename: 'Đổi tên dữ liệu',
    Backup: 'Sao lưu dữ liệu',
    Restore: 'Phục hồi dữ liệu',
    Delete: 'Xóa dữ liệu',
    DeleteBackup: 'Xóa dữ liệu sao lưu',
  },
};
